export class MobRenderer {
    static draw(ctx, mob, time) {
        const m = mob, x = m.x, y = m.y, w = m.w, h = m.h;
        const flash = m.hitTimer > 0 && Math.floor(m.hitTimer / 50) % 2 === 0;
        const walk = m.ground ? Math.sin(time / 120 + m.id * 7) * 3 : 0;
        const cx2 = x + w / 2, cy2 = y + h;
        ctx.save(); ctx.translate(cx2, cy2); ctx.scale(m.squash * (m.right ? 1 : -1), m.stretch); ctx.translate(-cx2, -cy2);
        switch (m.type) {
            case 'SLIME': {
                const bounce = m.ground ? 0 : Math.abs(m.vy) * 0.3;
                const cols = [['#44cc44', '#338833'], ['#cc4444', '#aa2222'], ['#4444cc', '#2222aa'], ['#cccc44', '#aaaa22']];
                const ci = m.colorIndex % 4; const bodyC = flash ? '#fff' : cols[ci][0], darkC = flash ? '#ccc' : cols[ci][1];
                ctx.fillStyle = darkC; ctx.fillRect(x + 1, y + h - 10 - bounce, w - 2, 10 + bounce);
                ctx.fillStyle = bodyC; ctx.fillRect(x + 2, y + h - 9 - bounce, w - 4, 8 + bounce);
                ctx.fillStyle = 'rgba(255,255,255,0.35)'; ctx.fillRect(x + 3, y + h - 8 - bounce, 4, 3);
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 3, y + h - 8 - bounce, 3, 3); ctx.fillRect(x + w - 6, y + h - 8 - bounce, 3, 3);
                ctx.fillStyle = '#111'; ctx.fillRect(x + 4, y + h - 7 - bounce, 1, 2); ctx.fillRect(x + w - 5, y + h - 7 - bounce, 1, 2); break;
            }
            case 'ZOMBIE': {
                ctx.fillStyle = flash ? '#aaa' : '#334422'; ctx.fillRect(x + 2, y + 16, 4, 8 + walk); ctx.fillRect(x + w - 6, y + 16, 4, 8 - walk);
                ctx.fillStyle = flash ? '#ccc' : '#556644'; ctx.fillRect(x + 1, y + 6, w - 2, 12);
                ctx.fillStyle = flash ? '#ddd' : '#445533'; ctx.fillRect(x + 2, y + 7, w - 4, 4);
                ctx.fillStyle = flash ? '#bbb' : '#668844'; ctx.fillRect(x - 3, y + 8, 4, 3); ctx.fillRect(x + w - 1, y + 8, 4, 3);
                ctx.fillStyle = flash ? '#ddd' : '#7a9955'; ctx.fillRect(x + 2, y, w - 4, 7);
                ctx.fillStyle = '#ff0'; ctx.fillRect(x + 3, y + 2, 2, 2); ctx.fillRect(x + w - 5, y + 2, 2, 2);
                ctx.fillStyle = '#300'; ctx.fillRect(x + 4, y + 3, 1, 1); ctx.fillRect(x + w - 4, y + 3, 1, 1);
                ctx.fillStyle = '#500'; ctx.fillRect(x + 5, y + 10, 2, 1); break;
            }
            case 'SKELETON': {
                ctx.fillStyle = flash ? '#fff' : '#ddddbb'; ctx.fillRect(x + 3, y + 16, 2, 8 + walk); ctx.fillRect(x + w - 5, y + 16, 2, 8 - walk);
                ctx.fillStyle = flash ? '#fff' : '#ccccaa'; for (let i = 0; i < 4; i++)ctx.fillRect(x + 3, y + 7 + i * 2, w - 6, 1);
                ctx.fillRect(x + w / 2 - 1, y + 6, 2, 12); ctx.fillRect(x - 2, y + 8, 3, 2); ctx.fillRect(x + w - 1, y + 8, 3, 2);
                ctx.fillStyle = flash ? '#fff' : '#eeeedd'; ctx.fillRect(x + 2, y, w - 4, 7);
                ctx.fillStyle = '#222'; ctx.fillRect(x + 3, y + 2, 2, 2); ctx.fillRect(x + w - 5, y + 2, 2, 2);
                ctx.fillStyle = flash ? '#eee' : '#ddddbb'; ctx.fillRect(x + 3, y + 5, w - 6, 2);
                ctx.fillStyle = '#222'; ctx.fillRect(x + 4, y + 5, 1, 1); ctx.fillRect(x + 6, y + 5, 1, 1); break;
            }
            case 'BAT': {
                const wingPhase = Math.sin(time / 60 + m.id * 3) * 4;
                ctx.fillStyle = flash ? '#fff' : '#443322'; ctx.fillRect(x + 4, y + 2, 4, 5);
                ctx.fillRect(x - 1, y + 1 + wingPhase * 0.3, 5, 3); ctx.fillRect(x + w - 4, y + 1 - wingPhase * 0.3, 5, 3);
                ctx.fillRect(x - 3, y + 2 + wingPhase * 0.5, 3, 2); ctx.fillRect(x + w - 1, y + 2 - wingPhase * 0.5, 3, 2);
                ctx.fillStyle = '#f44'; ctx.fillRect(x + 4, y + 3, 1, 1); ctx.fillRect(x + 7, y + 3, 1, 1); break;
            }
            case 'WOLF': {
                ctx.fillStyle = flash ? '#ddd' : '#777'; ctx.fillRect(x + 3, y + 2, w - 6, h - 6);
                ctx.fillStyle = flash ? '#eee' : '#999'; ctx.fillRect(x + 4, y + 3, w - 8, 3);
                ctx.fillStyle = flash ? '#bbb' : '#666';
                ctx.fillRect(x + 3, y + h - 5, 3, 5 + walk * 0.5); ctx.fillRect(x + 7, y + h - 5, 3, 5 - walk * 0.5);
                ctx.fillRect(x + w - 9, y + h - 5, 3, 5 - walk * 0.5); ctx.fillRect(x + w - 6, y + h - 5, 3, 5 + walk * 0.5);
                ctx.fillStyle = flash ? '#eee' : '#888'; ctx.fillRect(x + w - 6, y, 6, 6);
                ctx.fillRect(x + w - 6, y - 2, 2, 3); ctx.fillRect(x + w - 2, y - 2, 2, 3);
                ctx.fillStyle = '#ff0'; ctx.fillRect(x + w - 3, y + 2, 2, 1); ctx.fillStyle = '#333'; ctx.fillRect(x + w, y + 3, 2, 1);
                ctx.fillStyle = flash ? '#bbb' : '#777'; ctx.fillRect(x - 1, y + 1, 4, 2); break;
            }
            case 'SCORPION': {
                ctx.fillStyle = flash ? '#ddd' : '#8a6a30'; ctx.fillRect(x + 3, y + 2, w - 6, h - 3);
                ctx.fillStyle = flash ? '#ccc' : '#7a5a20'; ctx.fillRect(x + 5, y + 3, 2, h - 5); ctx.fillRect(x + w - 7, y + 3, 2, h - 5);
                ctx.fillStyle = flash ? '#eee' : '#9a7a40'; ctx.fillRect(x + w - 4, y, 4, 3); ctx.fillRect(x + w, y, 2, 2); ctx.fillRect(x + w - 4, y + h - 3, 4, 3);
                ctx.fillRect(x + 1, y + 1, 3, 2); ctx.fillRect(x - 1, y - 1, 2, 3); ctx.fillRect(x - 1, y - 3, 2, 3);
                ctx.fillStyle = '#ff4444'; ctx.fillRect(x - 2, y - 4, 1, 2);
                ctx.fillStyle = '#222'; ctx.fillRect(x + w - 6, y + 2, 1, 1); ctx.fillRect(x + w - 4, y + 2, 1, 1); break;
            }
            case 'RABBIT': {
                const hop = m.ground ? 0 : -2;
                ctx.fillStyle = flash ? '#fff' : '#c8b898'; ctx.fillRect(x + 1, y + 3 + hop, w - 2, h - 4);
                ctx.fillStyle = flash ? '#fff' : '#d8c8a8'; ctx.fillRect(x + w - 5, y + 1 + hop, 5, 4);
                ctx.fillRect(x + w - 4, y - 2 + hop, 1, 4); ctx.fillRect(x + w - 2, y - 2 + hop, 1, 4);
                ctx.fillStyle = '#333'; ctx.fillRect(x + w - 2, y + 2 + hop, 1, 1);
                ctx.fillStyle = '#fff'; ctx.fillRect(x, y + 4 + hop, 2, 2); break;
            }
            case 'BEAR': {
                ctx.fillStyle = flash ? '#ddd' : '#664422'; ctx.fillRect(x + 3, y + 4, w - 6, h - 8);
                ctx.fillStyle = flash ? '#ccc' : '#553311'; ctx.fillRect(x + 4, y + 5, w - 8, h - 10);
                ctx.fillStyle = flash ? '#bbb' : '#553322'; ctx.fillRect(x + 3, y + h - 5, 4, 5 + walk * 0.4); ctx.fillRect(x + w - 7, y + h - 5, 4, 5 - walk * 0.4);
                ctx.fillStyle = flash ? '#eee' : '#775533'; ctx.fillRect(x + w - 8, y, 8, 7);
                ctx.fillStyle = flash ? '#ddd' : '#664422'; ctx.fillRect(x + w - 8, y - 2, 3, 3); ctx.fillRect(x + w - 3, y - 2, 3, 3);
                ctx.fillStyle = '#aa8866'; ctx.fillRect(x + w - 5, y + 4, 4, 2);
                ctx.fillStyle = '#222'; ctx.fillRect(x + w - 6, y + 2, 1, 1); ctx.fillRect(x + w - 3, y + 2, 1, 1);
                ctx.fillStyle = '#111'; ctx.fillRect(x + w - 4, y + 4, 1, 1); break;
            }
            case 'MUMMY': {
                ctx.fillStyle = flash ? '#fff' : '#d8c8a0'; ctx.fillRect(x + 1, y + 6, w - 2, 12);
                ctx.fillStyle = flash ? '#eee' : '#c8b890'; for (let i = 0; i < 4; i++)ctx.fillRect(x + 2, y + 7 + i * 3, w - 4, 1);
                ctx.fillRect(x + 2, y + 16, 4, 8 + walk); ctx.fillRect(x + w - 6, y + 16, 4, 8 - walk);
                ctx.fillStyle = flash ? '#fff' : '#e0d0b0'; ctx.fillRect(x + 2, y, w - 4, 7);
                ctx.fillStyle = flash ? '#eee' : '#c8b890'; ctx.fillRect(x + 2, y + 1, w - 4, 1); ctx.fillRect(x + 2, y + 4, w - 4, 1);
                const eg = Math.sin(time / 200) * 0.3 + 0.7; ctx.fillStyle = `rgba(255,${100 + eg * 100 | 0},0,${eg})`;
                ctx.fillRect(x + 3, y + 2, 2, 2); ctx.fillRect(x + w - 5, y + 2, 2, 2);
                ctx.fillStyle = flash ? '#ddd' : '#d8c8a0'; ctx.fillRect(x - 3, y + 8, 4, 3); ctx.fillRect(x + w - 1, y + 8, 4, 3); break;
            }
            case 'JAGUAR': {
                ctx.fillStyle = flash ? '#ddd' : '#cc9933'; ctx.fillRect(x + 3, y + 2, w - 6, h - 5);
                ctx.fillStyle = flash ? '#bbb' : '#885511'; ctx.fillRect(x + 5, y + 3, 2, 2); ctx.fillRect(x + 9, y + 4, 2, 2); ctx.fillRect(x + 7, y + 6, 2, 2);
                ctx.fillStyle = flash ? '#ccc' : '#bb8822'; ctx.fillRect(x + 3, y + h - 4, 3, 4 + walk * 0.6); ctx.fillRect(x + w - 6, y + h - 4, 3, 4 - walk * 0.6);
                ctx.fillStyle = flash ? '#eee' : '#ddaa44'; ctx.fillRect(x + w - 6, y, 6, 5);
                ctx.fillRect(x + w - 6, y - 1, 2, 2); ctx.fillRect(x + w - 2, y - 1, 2, 2);
                ctx.fillStyle = '#2a2'; ctx.fillRect(x + w - 3, y + 1, 2, 1); ctx.fillStyle = '#555'; ctx.fillRect(x + w, y + 3, 2, 1);
                ctx.fillStyle = flash ? '#ccc' : '#cc9933'; ctx.fillRect(x - 2, y + 1, 5, 2); break;
            }
            case 'LION': {
                ctx.fillStyle = flash ? '#ddd' : '#cc9944'; ctx.fillRect(x + 4, y + 4, w - 8, h - 7);
                ctx.fillStyle = flash ? '#eee' : '#aa6622'; ctx.fillRect(x + w - 9, y - 2, 10, 10);
                ctx.fillStyle = flash ? '#fff' : '#ddaa55'; ctx.fillRect(x + w - 7, y, 6, 6);
                ctx.fillStyle = flash ? '#ccc' : '#bb8833'; ctx.fillRect(x + 4, y + h - 5, 3, 5 + walk * 0.4); ctx.fillRect(x + w - 7, y + h - 5, 3, 5 - walk * 0.4);
                ctx.fillStyle = '#431'; ctx.fillRect(x + w - 4, y + 2, 2, 1); ctx.fillStyle = '#333'; ctx.fillRect(x + w - 2, y + 4, 2, 1);
                ctx.fillStyle = flash ? '#ccc' : '#cc9944'; ctx.fillRect(x - 1, y + 3, 5, 2);
                ctx.fillStyle = flash ? '#aa8' : '#885522'; ctx.fillRect(x - 3, y + 2, 3, 3); break;
            }
            case 'UNICORN': {
                ctx.fillStyle = flash ? '#fff' : '#eeeeff'; ctx.fillRect(x + 3, y + 6, w - 6, h - 10);
                ctx.fillStyle = flash ? '#eee' : '#ddddee'; ctx.fillRect(x + 3, y + h - 5, 3, 5 + walk * 0.4); ctx.fillRect(x + w - 6, y + h - 5, 3, 5 - walk * 0.4);
                ctx.fillRect(x + w - 7, y + 2, 7, 6);
                const hg = Math.sin(time / 300) * 0.3 + 0.7; ctx.fillStyle = `rgba(255,${200 + hg * 55 | 0},${100 + hg * 80 | 0},1)`;
                ctx.fillRect(x + w - 4, y - 3, 2, 5); ctx.fillRect(x + w - 4, y - 5, 1, 3);
                const rc = ['#ff4444', '#ffaa44', '#ffff44', '#44ff44', '#4444ff', '#aa44ff'];
                for (let i = 0; i < 4; i++) { ctx.fillStyle = rc[i % rc.length]; ctx.fillRect(x + w - 8, y + 1 + i * 2, 2, 2); }
                ctx.fillStyle = '#a4f'; ctx.fillRect(x + w - 4, y + 4, 2, 1);
                for (let i = 0; i < 3; i++) { ctx.fillStyle = rc[(i + 2) % rc.length]; ctx.fillRect(x - i, y + 5 + i, 2, 2); } break;
            }
            case 'FIRE_ELEM': {
                const fl = Math.sin(time / 100 + m.id) * 2;
                ctx.fillStyle = flash ? '#fff' : '#ff4400'; ctx.fillRect(x + 3, y + 2 + fl * 0.3, w - 6, h - 4);
                ctx.fillStyle = flash ? '#ffe' : '#ffaa00'; ctx.fillRect(x + 4, y + 3 + fl * 0.5, w - 8, h - 6);
                ctx.fillStyle = '#ffdd44'; ctx.fillRect(x + 5, y + 4 + fl, w - 10, h - 8);
                ctx.fillStyle = '#ff6600'; ctx.fillRect(x + 3, y + fl, 3, 3); ctx.fillRect(x + w - 6, y - 1 + fl * 0.5, 3, 3); ctx.fillRect(x + w / 2 - 1, y - 2 + fl * 0.8, 3, 3);
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 4, y + 5 + fl * 0.5, 2, 2); ctx.fillRect(x + w - 6, y + 5 + fl * 0.5, 2, 2); break;
            }
            case 'ENT': {
                ctx.fillStyle = flash ? '#ddd' : '#5a4020'; ctx.fillRect(x + 5, y + 8, w - 10, h - 10);
                ctx.fillStyle = flash ? '#ccc' : '#4a3018'; ctx.fillRect(x + 7, y + 10, 2, h - 14); ctx.fillRect(x + w - 9, y + 12, 2, h - 16);
                ctx.fillRect(x + 4, y + h - 5, 4, 5 + walk * 0.3); ctx.fillRect(x + w - 8, y + h - 5, 4, 5 - walk * 0.3);
                ctx.fillStyle = flash ? '#aea' : '#2a5a10';
                for (let dx = -3; dx <= 3; dx++)for (let dy = -2; dy <= 2; dy++) { if (Math.abs(dx) + Math.abs(dy) < 5) ctx.fillRect(x + w / 2 + dx * 3 - 1, y + dy * 3, 4, 4); }
                ctx.fillStyle = '#4a2'; ctx.fillRect(x + 7, y + 12, 3, 2); ctx.fillRect(x + w - 10, y + 12, 3, 2);
                ctx.fillStyle = '#2a1'; ctx.fillRect(x + 8, y + 12, 1, 2); ctx.fillRect(x + w - 9, y + 12, 1, 2);
                ctx.fillStyle = flash ? '#ccc' : '#5a4020'; ctx.fillRect(x - 2, y + 10, 7, 3); ctx.fillRect(x + w - 5, y + 10, 7, 3);
                ctx.fillStyle = flash ? '#aea' : '#3a7a1a'; ctx.fillRect(x - 4, y + 8, 4, 3); ctx.fillRect(x + w, y + 8, 4, 3); break;
            }
            case 'ICE_GOLEM': {
                ctx.fillStyle = flash ? '#fff' : '#88bbdd'; ctx.fillRect(x + 2, y + 6, w - 4, h - 10);
                ctx.fillStyle = flash ? '#eef' : '#aaddee'; ctx.fillRect(x + 4, y + 8, 4, 4); ctx.fillRect(x + w - 8, y + 10, 4, 4);
                ctx.fillStyle = flash ? '#ddf' : '#7799bb'; ctx.fillRect(x + 3, y + h - 5, 4, 5 + walk * 0.3); ctx.fillRect(x + w - 7, y + h - 5, 4, 5 - walk * 0.3);
                ctx.fillStyle = flash ? '#fff' : '#99ccee'; ctx.fillRect(x + 3, y, w - 6, 7);
                ctx.fillStyle = '#aaeeff'; ctx.fillRect(x + w / 2 - 2, y - 3, 4, 4); ctx.fillStyle = '#ccf'; ctx.fillRect(x + w / 2 - 1, y - 4, 2, 2);
                ctx.fillStyle = '#44aaff'; ctx.fillRect(x + 4, y + 2, 2, 2); ctx.fillRect(x + w - 6, y + 2, 2, 2);
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 5, y + 2, 1, 1); ctx.fillRect(x + w - 5, y + 2, 1, 1);
                ctx.fillStyle = flash ? '#ddf' : '#88bbdd'; ctx.fillRect(x - 3, y + 8, 4, 4); ctx.fillRect(x + w - 1, y + 8, 4, 4); break;
            }
            case 'SHROOM_ZOMBIE': {
                ctx.fillStyle = flash ? '#aaa' : '#446633'; ctx.fillRect(x + 2, y + 16, 4, 6 + walk); ctx.fillRect(x + w - 6, y + 16, 4, 6 - walk);
                ctx.fillStyle = flash ? '#ccc' : '#557744'; ctx.fillRect(x + 1, y + 6, w - 2, 12);
                ctx.fillStyle = flash ? '#faa' : '#cc3333'; ctx.fillRect(x, y - 2, w, 5);
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 2, y - 1, 2, 2); ctx.fillRect(x + w - 4, y, 2, 2);
                ctx.fillStyle = flash ? '#ddd' : '#668844'; ctx.fillRect(x + 2, y + 2, w - 4, 5);
                ctx.fillStyle = '#8f8'; ctx.fillRect(x + 3, y + 3, 2, 2); ctx.fillRect(x + w - 5, y + 3, 2, 2);
                ctx.fillStyle = 'rgba(100,255,100,0.4)'; ctx.fillRect(x - 1 + Math.sin(time / 200) * 2, y + 2, 2, 2); break;
            }
            case 'CRAB': {
                ctx.fillStyle = flash ? '#fbb' : '#cc4433'; ctx.fillRect(x + 2, y + 1, w - 4, h - 3);
                ctx.fillStyle = flash ? '#fcc' : '#dd5544'; ctx.fillRect(x + 3, y + 2, w - 6, 3);
                ctx.fillStyle = flash ? '#daa' : '#aa3322'; for (let i = 0; i < 3; i++) { ctx.fillRect(x - 1, y + 2 + i * 2, 3, 1); ctx.fillRect(x + w - 2, y + 2 + i * 2, 3, 1); }
                ctx.fillStyle = flash ? '#fcc' : '#dd4433'; ctx.fillRect(x - 3, y, 4, 3); ctx.fillRect(x + w - 1, y, 4, 3);
                ctx.fillRect(x - 4, y, 2, 2); ctx.fillRect(x + w + 1, y, 2, 2);
                ctx.fillStyle = '#222'; ctx.fillRect(x + 3, y - 1, 2, 2); ctx.fillRect(x + w - 5, y - 1, 2, 2); break;
            }
            case 'SHADOW': {
                const pulse = Math.sin(time / 150) * 0.3 + 0.7; ctx.globalAlpha = flash ? 1 : pulse * 0.8;
                ctx.fillStyle = flash ? '#fff' : '#3a1a5a'; ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                ctx.fillStyle = flash ? '#ddd' : '#2a0a3a'; ctx.fillRect(x + 3, y + 3, w - 6, h - 6);
                ctx.fillStyle = `rgba(200,50,255,${pulse})`; ctx.fillRect(x + 3, y + 5, 3, 2); ctx.fillRect(x + w - 6, y + 5, 3, 2);
                ctx.fillStyle = `rgba(150,30,200,${pulse * 0.5})`;
                ctx.fillRect(x - 2 + Math.sin(time / 120) * 3, y + h - 4, 3, 4); ctx.fillRect(x + w - 1 + Math.sin(time / 140 + 1) * 3, y + h - 3, 3, 3);
                ctx.globalAlpha = 1; break;
            }
            case 'DEMON': {
                ctx.fillStyle = flash ? '#fff' : '#cc2222'; ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                ctx.fillStyle = flash ? '#fcc' : '#881111'; ctx.fillRect(x + 3, y + 3, w - 6, h - 6);
                const wf = Math.sin(time / 100 + m.id) * 3;
                ctx.fillStyle = flash ? '#faa' : '#aa1111'; ctx.fillRect(x - 4, y + 2 + wf * 0.3, 5, 6); ctx.fillRect(x + w - 1, y + 2 - wf * 0.3, 5, 6);
                ctx.fillStyle = flash ? '#fdd' : '#881111'; ctx.fillRect(x + 2, y - 2, 2, 4); ctx.fillRect(x + w - 4, y - 2, 2, 4);
                ctx.fillStyle = '#ff0'; ctx.fillRect(x + 4, y + 4, 2, 2); ctx.fillRect(x + w - 6, y + 4, 2, 2); break;
            }
            // NEW MOB RENDERS
            case 'CAVE_SPIDER': {
                ctx.fillStyle = flash ? '#fff' : '#553322'; ctx.fillRect(x + 2, y + 1, w - 4, h - 2);
                ctx.fillStyle = flash ? '#eee' : '#443311'; ctx.fillRect(x + 3, y + 2, w - 6, h - 4);
                ctx.fillStyle = flash ? '#ddd' : '#664433';
                for (let i = 0; i < 3; i++) { ctx.fillRect(x - 2, y + 1 + i * 2, 3, 1); ctx.fillRect(x + w - 1, y + 1 + i * 2, 3, 1); }
                ctx.fillStyle = '#f00'; ctx.fillRect(x + 3, y + 1, 1, 1); ctx.fillRect(x + w - 4, y + 1, 1, 1);
                ctx.fillRect(x + 4, y + 1, 1, 1); ctx.fillRect(x + w - 5, y + 1, 1, 1); break;
            }
            case 'GOLEM': {
                ctx.fillStyle = flash ? '#ccc' : '#888'; ctx.fillRect(x + 3, y + 6, w - 6, h - 10);
                ctx.fillStyle = flash ? '#bbb' : '#777'; ctx.fillRect(x + 5, y + 8, w - 10, h - 14);
                ctx.fillStyle = flash ? '#aaa' : '#666'; ctx.fillRect(x + 4, y + h - 5, 5, 5 + walk * 0.2); ctx.fillRect(x + w - 9, y + h - 5, 5, 5 - walk * 0.2);
                ctx.fillStyle = flash ? '#ddd' : '#999'; ctx.fillRect(x + 4, y, w - 8, 8);
                ctx.fillStyle = '#4a4'; ctx.fillRect(x + 6, y + 2, 2, 3); ctx.fillRect(x + w - 8, y + 2, 2, 3);
                ctx.fillStyle = flash ? '#bbb' : '#888'; ctx.fillRect(x - 2, y + 8, 5, 5); ctx.fillRect(x + w - 3, y + 8, 5, 5);
                ctx.fillStyle = '#556'; ctx.fillRect(x + 5, y + 10, 2, 2); ctx.fillRect(x + w - 7, y + 12, 2, 2); break;
            }
            case 'CRYSTAL_BUG': {
                const pulse2 = Math.sin(time / 300 + m.id * 2) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(150,120,255,${pulse2})`; ctx.fillRect(x + 1, y + 1, w - 2, h - 2);
                ctx.fillStyle = `rgba(200,180,255,${pulse2 * 0.8})`; ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                const wf2 = Math.sin(time / 80 + m.id) * 3;
                ctx.fillStyle = `rgba(180,150,255,${pulse2 * 0.6})`;
                ctx.fillRect(x - 2, y + 1 + wf2 * 0.3, 3, 2); ctx.fillRect(x + w - 1, y + 1 - wf2 * 0.3, 3, 2);
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 2, y + 2, 1, 1); ctx.fillRect(x + w - 3, y + 2, 1, 1); break;
            }
            case 'MAGMA_SLIME': {
                const bounce2 = m.ground ? 0 : Math.abs(m.vy) * 0.3;
                const mg = Math.sin(time / 150 + m.id) * 0.3 + 0.7;
                ctx.fillStyle = flash ? '#fff' : `rgb(${180 + mg * 50 | 0},${30 + mg * 30 | 0},0)`;
                ctx.fillRect(x + 1, y + h - 10 - bounce2, w - 2, 10 + bounce2);
                ctx.fillStyle = flash ? '#ffa' : `rgb(${220 + mg * 35 | 0},${60 + mg * 40 | 0},0)`;
                ctx.fillRect(x + 2, y + h - 9 - bounce2, w - 4, 8 + bounce2);
                ctx.fillStyle = 'rgba(255,200,50,0.4)'; ctx.fillRect(x + 3, y + h - 8 - bounce2, 4, 3);
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 3, y + h - 8 - bounce2, 3, 3); ctx.fillRect(x + w - 6, y + h - 8 - bounce2, 3, 3);
                ctx.fillStyle = '#111'; ctx.fillRect(x + 4, y + h - 7 - bounce2, 1, 2); ctx.fillRect(x + w - 5, y + h - 7 - bounce2, 1, 2); break;
            }
            case 'CAVE_WORM': {
                // Head (drawn inside the flip transform)
                ctx.fillStyle = flash ? '#fff' : '#5a7a30';
                ctx.fillRect(x + 1, y + 1, w - 2, h - 2);
                ctx.fillStyle = flash ? '#efe' : '#6a8a40';
                ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                // Mandibles
                ctx.fillStyle = '#3a5a20';
                ctx.fillRect(x + w - 2, y + 2, 4, 3);
                ctx.fillRect(x + w - 2, y + h - 5, 4, 3);
                // Eyes
                ctx.fillStyle = '#ff4444';
                ctx.fillRect(x + w - 4, y + 3, 2, 2);
                ctx.fillRect(x + w - 4, y + h - 5, 2, 2);
                // Exit flip transform so segments render in world space
                ctx.restore();
                // Body segments trail — drawn without flip so they trail smoothly
                if (m.segments) {
                    for (let i = 0; i < m.segments.length; i++) {
                        const s = m.segments[i]; const sz = 1 - i * 0.08;
                        const sw = w * sz, sh = h * sz;
                        ctx.fillStyle = `rgb(${90 - i * 5},${120 - i * 6},${50 - i * 3})`;
                        ctx.fillRect(s.x - sw / 2, s.y - sh / 2, sw, sh);
                        ctx.fillStyle = `rgb(${100 - i * 5},${140 - i * 6},${60 - i * 3})`;
                        ctx.fillRect(s.x - sw / 2 + 1, s.y - sh / 2 + 1, sw - 2, sh - 2);
                    }
                }
                // Re-save to keep balanced with the outer ctx.restore()
                ctx.save();
                break;
            }
            case 'DEEP_EYE': {
                const pulse = Math.sin(time / 200 + m.id) * 0.3 + 0.7;
                const eyeR = Math.min(w, h) / 2;
                const cx2 = x + w / 2, cy2 = y + h / 2;
                // Outer glow
                ctx.fillStyle = `rgba(180,50,50,${pulse * 0.3})`;
                ctx.fillRect(cx2 - eyeR - 2, cy2 - eyeR - 2, eyeR * 2 + 4, eyeR * 2 + 4);
                // Eyeball
                ctx.fillStyle = flash ? '#fff' : `rgb(${200 + pulse * 55 | 0},${180 + pulse * 40 | 0},${160 + pulse * 30 | 0})`;
                ctx.fillRect(cx2 - eyeR, cy2 - eyeR, eyeR * 2, eyeR * 2);
                // Iris
                ctx.fillStyle = '#880022';
                ctx.fillRect(cx2, cy2 - 2, 4, 5);
                // Pupil
                ctx.fillStyle = '#110000';
                ctx.fillRect(cx2 + 1, cy2 - 1, 2, 3);
                // Veins
                ctx.fillStyle = 'rgba(200,50,50,0.5)';
                ctx.fillRect(cx2 - eyeR, cy2, 3, 1);
                ctx.fillRect(cx2 + eyeR - 3, cy2 - 1, 3, 1);
                ctx.fillRect(cx2 - 1, cy2 - eyeR, 1, 3);
                break;
            }
            case 'SKELETON_MINER': {
                // Body
                ctx.fillStyle = flash ? '#fff' : '#d8d0b8';
                ctx.fillRect(x + 3, y + 2, w - 6, 6); // skull
                ctx.fillRect(x + 4, y + 8, w - 8, 10); // ribcage
                ctx.fillRect(x + 4, y + 18, 3, 6); ctx.fillRect(x + w - 7, y + 18, 3, 6); // legs
                // Eyes
                ctx.fillStyle = '#222';
                ctx.fillRect(x + 4, y + 4, 2, 2); ctx.fillRect(x + w - 6, y + 4, 2, 2);
                // Hard hat
                ctx.fillStyle = flash ? '#ff8' : '#dda030';
                ctx.fillRect(x + 2, y, w - 4, 3);
                ctx.fillRect(x + 1, y + 2, w - 2, 1);
                // Pickaxe
                const pkSwing = Math.sin(time / 300 + m.id) * 0.5;
                ctx.fillStyle = '#6a4a2a';
                ctx.fillRect(x + w - 1, y + 8 + pkSwing * 3, 5, 2);
                ctx.fillStyle = '#aaa';
                ctx.fillRect(x + w + 2, y + 6 + pkSwing * 3, 3, 3);
                break;
            }
            case 'LAVA_SERPENT': {
                const wv = Math.sin(time / 120 + m.id) * 2;
                // Body
                ctx.fillStyle = flash ? '#fff' : '#cc4400';
                ctx.fillRect(x + 1, y + 2 + wv * 0.3, w - 2, h - 4);
                ctx.fillStyle = '#ff6600';
                ctx.fillRect(x + 2, y + 3 + wv * 0.3, w - 4, h - 6);
                // Glow core
                ctx.fillStyle = `rgba(255,200,50,${0.4 + Math.sin(time / 100) * 0.2})`;
                ctx.fillRect(x + 3, y + 4 + wv * 0.3, w - 6, h - 8);
                // Eyes
                ctx.fillStyle = '#fff';
                ctx.fillRect(x + w - 4, y + 3 + wv * 0.3, 2, 2);
                // Flame tail
                for (let i = 0; i < 3; i++) {
                    const fx = x - 3 - i * 3;
                    ctx.fillStyle = `rgba(255,${100 + i * 40},0,${0.7 - i * 0.2})`;
                    ctx.fillRect(fx, y + 3 + Math.sin(time / 80 + i) * 2, 3, h - 6);
                }
                break;
            }
            case 'SHROOM_BEETLE': {
                const bob = Math.sin(time / 100 + m.id * 3) * 1;
                // Body
                ctx.fillStyle = flash ? '#fff' : '#2a5a2a';
                ctx.fillRect(x + 1, y + 2 + bob, w - 2, h - 3);
                // Shell pattern
                ctx.fillStyle = '#3a7a3a';
                ctx.fillRect(x + 2, y + 2 + bob, w - 4, 2);
                // Glow spots
                ctx.fillStyle = `rgba(100,255,100,${0.5 + Math.sin(time / 200 + m.id) * 0.3})`;
                ctx.fillRect(x + 2, y + 3 + bob, 2, 1); ctx.fillRect(x + w - 4, y + 3 + bob, 2, 1);
                // Legs
                ctx.fillStyle = '#1a3a1a';
                ctx.fillRect(x, y + h - 2 + bob, 2, 2); ctx.fillRect(x + w - 2, y + h - 2 + bob, 2, 2);
                // Antennae
                ctx.fillStyle = '#4a8a4a';
                ctx.fillRect(x + w - 1, y + bob, 1, 2);
                ctx.fillRect(x + w, y - 1 + bob, 1, 2);
                break;
            }
            case 'FROST_BAT': {
                const wingFlap = Math.sin(time / 60 + m.id) * 4;
                // Wings
                ctx.fillStyle = flash ? '#fff' : '#8ab8d8';
                ctx.fillRect(x - 3, y + 2 + wingFlap, 6, 4);
                ctx.fillRect(x + w - 3, y + 2 - wingFlap, 6, 4);
                // Body
                ctx.fillStyle = flash ? '#fff' : '#6a98b8';
                ctx.fillRect(x + 2, y + 1, w - 4, h - 2);
                // Face
                ctx.fillStyle = '#aaddff';
                ctx.fillRect(x + 3, y + 2, w - 6, h - 4);
                // Eyes
                ctx.fillStyle = '#00ddff';
                ctx.fillRect(x + 3, y + 3, 2, 2); ctx.fillRect(x + w - 5, y + 3, 2, 2);
                ctx.fillStyle = '#003';
                ctx.fillRect(x + 4, y + 4, 1, 1); ctx.fillRect(x + w - 4, y + 4, 1, 1);
                // Ice particles
                for (let i = 0; i < 2; i++) {
                    const px = x + Math.sin(time / 150 + m.id + i * 2) * 8;
                    const py = y + h + 2 + i * 4 + Math.sin(time / 200 + i) * 2;
                    ctx.fillStyle = `rgba(180,220,255,${0.6 - i * 0.2})`;
                    ctx.fillRect(px, py, 2, 2);
                }
                break;
            }
            case 'VILLAGER': {
                const prof = m.ai ? m.ai.profession : 0;
                // Profession-based colors
                const profShirts = ['#6a3a1a', '#5a8a2a', '#4a4a6a', '#5a3a7a', '#eee', '#7a6a5a', '#2a6a4a'];
                const profHats = ['#4a4a4a', '#c0a040', '#6a6a7a', '#6a3a6a', '#fff', '#8a6a40', '#3a7a3a'];
                const profAprons = ['#5a4a3a', '#8a7a40', null, '#ddd', '#fff', '#6a5a4a', '#4a8a3a'];
                const shirtCol = profShirts[prof] || '#3a7a3a';
                const hatCol = profHats[prof] || '#cc3333';
                const apronCol = profAprons[prof];

                // Sleeping pose
                const isSleeping = m.ai && m.ai.state === 'v_sleep';

                // Legs
                ctx.fillStyle = flash ? '#faa' : '#6a5030';
                ctx.fillRect(x + 2, y + 14, 3, 8 + walk * 0.4); ctx.fillRect(x + w - 5, y + 14, 3, 8 - walk * 0.4);
                // Shoes
                ctx.fillStyle = '#4a3020';
                ctx.fillRect(x + 1, y + 21 + walk * 0.3, 4, 1); ctx.fillRect(x + w - 5, y + 21 - walk * 0.3, 4, 1);
                // Body / shirt
                ctx.fillStyle = flash ? '#fcc' : shirtCol;
                ctx.fillRect(x + 1, y + 6, w - 2, 9);
                // Belt
                ctx.fillStyle = '#3a2a1a'; ctx.fillRect(x + 1, y + 13, w - 2, 2);
                ctx.fillStyle = '#aa8833'; ctx.fillRect(x + 4, y + 13, 2, 2);
                // Arms
                const armS = Math.abs(m.vx) > 0.3 ? Math.sin(time / 120 + m.id * 5) * 2 : 0;
                const workAnim = (m.ai && m.ai.state === 'v_work') ? Math.sin(time / 140) * 3 : 0;
                ctx.fillStyle = flash ? '#fcc' : '#ffcc88';
                ctx.fillRect(x - 1, y + 7 + armS + workAnim, 2, 6); ctx.fillRect(x + w - 1, y + 7 - armS - workAnim, 2, 6);
                // Apron (profession-based)
                if (apronCol) {
                    ctx.fillStyle = apronCol; ctx.fillRect(x + 2, y + 10, w - 4, 5);
                }
                // Guard armor overlay
                if (prof === 2) {
                    ctx.fillStyle = '#7a7a8a'; ctx.fillRect(x + 1, y + 6, w - 2, 3); // shoulder plates
                    ctx.fillStyle = '#5a5a6a'; ctx.fillRect(x - 1, y + 6, 2, 3); ctx.fillRect(x + w - 1, y + 6, 2, 3);
                }
                // Head
                ctx.fillStyle = flash ? '#fcc' : '#ffcc88';
                ctx.fillRect(x + 2, y, 6, 7);
                // Hair
                const hairs = ['#3a2010', '#6a4a20', '#2a1a0a', '#8a6a30', '#4a2a1a', '#1a1a1a', '#8a3a1a'];
                ctx.fillStyle = hairs[m.id % hairs.length];
                ctx.fillRect(x + 1, y - 1, 8, 3);
                ctx.fillRect(x + 1, y + 1, 2, 2);
                ctx.fillRect(x + 8, y + 1, 1, 3);
                // Eyes (closed when sleeping)
                if (isSleeping) {
                    ctx.fillStyle = '#aa8866'; ctx.fillRect(x + 5, y + 3, 2, 1);
                } else {
                    ctx.fillStyle = '#fff';
                    ctx.fillRect(x + 5, y + 2, 2, 2); ctx.fillStyle = '#222'; ctx.fillRect(x + 6, y + 3, 1, 1);
                }
                // Nose
                ctx.fillStyle = '#eebb88'; ctx.fillRect(x + 6, y + 4, 1, 1);
                // Hat (profession-based)
                ctx.fillStyle = hatCol;
                if (prof === 4) { // cook hat — tall
                    ctx.fillRect(x + 1, y - 3, 8, 3); ctx.fillRect(x + 2, y - 7, 6, 5);
                    ctx.fillRect(x + 3, y - 9, 4, 3);
                } else if (prof === 2) { // guard helmet
                    ctx.fillRect(x, y - 3, w, 4); ctx.fillRect(x + 3, y - 5, w - 6, 3);
                    ctx.fillStyle = '#8a8a9a'; ctx.fillRect(x + 1, y - 1, w - 2, 1); // visor
                } else {
                    ctx.fillRect(x, y - 3, w, 3); ctx.fillRect(x + 2, y - 5, w - 4, 3);
                }
                // Profession tool indicator
                if (prof === 0) { // blacksmith — hammer
                    ctx.fillStyle = '#888'; ctx.fillRect(x + w, y + 9 + workAnim, 2, 5);
                    ctx.fillStyle = '#aaa'; ctx.fillRect(x + w - 1, y + 8 + workAnim, 4, 2);
                } else if (prof === 1) { // farmer — hoe
                    ctx.fillStyle = '#6a4a2a'; ctx.fillRect(x + w, y + 8, 1, 7);
                    ctx.fillStyle = '#888'; ctx.fillRect(x + w - 1, y + 7, 3, 2);
                } else if (prof === 2) { // guard — spear
                    ctx.fillStyle = '#6a5a3a'; ctx.fillRect(x + w, y + 3, 1, 14);
                    ctx.fillStyle = '#bbb'; ctx.fillRect(x + w - 1, y + 1, 3, 3);
                } else if (prof === 3) { // librarian — book
                    ctx.fillStyle = '#8a2a2a'; ctx.fillRect(x + w, y + 10, 3, 4);
                    ctx.fillStyle = '#fff'; ctx.fillRect(x + w + 1, y + 11, 1, 2);
                }
                break;
            }
            // === NEW MOB RENDERS ===
            case 'HARPY': {
                const wf3 = Math.sin(time / 70 + m.id) * 5;
                // Wings
                ctx.fillStyle = flash ? '#fff' : '#aa88cc';
                ctx.fillRect(x - 5, y + 1 + wf3 * 0.4, 8, 5); ctx.fillRect(x + w - 3, y + 1 - wf3 * 0.4, 8, 5);
                ctx.fillRect(x - 8, y + 2 + wf3 * 0.6, 4, 3); ctx.fillRect(x + w + 2, y + 2 - wf3 * 0.6, 4, 3);
                // Body
                ctx.fillStyle = flash ? '#fdd' : '#ffccaa';
                ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                // Head
                ctx.fillStyle = flash ? '#fee' : '#ffddbb';
                ctx.fillRect(x + 3, y, w - 6, 6);
                // Eyes
                ctx.fillStyle = '#c44'; ctx.fillRect(x + 4, y + 2, 2, 2); ctx.fillRect(x + w - 6, y + 2, 2, 2);
                // Talons
                ctx.fillStyle = '#886644';
                ctx.fillRect(x + 3, y + h - 2, 2, 3); ctx.fillRect(x + w - 5, y + h - 2, 2, 3); break;
            }
            case 'WYVERN': {
                const wv2 = Math.sin(time / 80 + m.id) * 3;
                // Long serpentine body
                ctx.fillStyle = flash ? '#fff' : '#4488aa';
                ctx.fillRect(x + 1, y + 2 + wv2 * 0.3, w - 2, h - 4);
                ctx.fillStyle = '#55aacc'; ctx.fillRect(x + 2, y + 3 + wv2 * 0.3, w - 4, h - 6);
                // Scales
                ctx.fillStyle = '#3377aa';
                for (let i = 0; i < 4; i++) ctx.fillRect(x + 3 + i * 4, y + 5 + wv2 * 0.2, 3, 2);
                // Wings
                ctx.fillStyle = flash ? '#def' : '#6699bb';
                ctx.fillRect(x - 4, y - 2 + wv2, 6, 8); ctx.fillRect(x + w - 2, y - 2 - wv2, 6, 8);
                ctx.fillRect(x - 8, y + wv2 * 1.2, 5, 5); ctx.fillRect(x + w + 2, y - wv2 * 1.2, 5, 5);
                // Head
                ctx.fillStyle = flash ? '#fff' : '#336688';
                ctx.fillRect(x + w - 5, y + 3 + wv2 * 0.2, 7, 6);
                ctx.fillStyle = '#ff4444'; ctx.fillRect(x + w - 2, y + 5 + wv2 * 0.2, 2, 2);
                // Horn
                ctx.fillStyle = '#aaddff'; ctx.fillRect(x + w - 3, y + 1, 2, 3); break;
            }
            case 'PIRANHA': {
                const sw3 = Math.sin(time / 100 + m.id) * 1;
                ctx.fillStyle = flash ? '#faa' : '#cc3322'; ctx.fillRect(x + 1, y + 1 + sw3, w - 2, h - 2);
                ctx.fillStyle = '#dd5544'; ctx.fillRect(x + 2, y + 2 + sw3, w - 4, h - 4);
                // Fin
                ctx.fillStyle = '#aa2211'; ctx.fillRect(x - 1, y + sw3, 3, 3); ctx.fillRect(x + w / 2, y - 1 + sw3, 3, 2);
                // Eye
                ctx.fillStyle = '#ff0'; ctx.fillRect(x + w - 3, y + 2 + sw3, 2, 2);
                ctx.fillStyle = '#111'; ctx.fillRect(x + w - 2, y + 2 + sw3, 1, 1);
                // Teeth
                ctx.fillStyle = '#fff'; ctx.fillRect(x + w - 1, y + 4 + sw3, 1, 1); ctx.fillRect(x + w, y + 3 + sw3, 1, 1); break;
            }
            case 'JELLYFISH': {
                const jb = Math.sin(time / 200 + m.id * 2) * 2;
                const jGlow = Math.sin(time / 300 + m.id) * 0.3 + 0.7;
                // Bell
                ctx.fillStyle = `rgba(100,200,255,${jGlow * 0.7})`;
                ctx.fillRect(x + 1, y + 1 + jb, w - 2, 6);
                ctx.fillStyle = `rgba(150,230,255,${jGlow * 0.5})`;
                ctx.fillRect(x + 2, y + 2 + jb, w - 4, 4);
                // Tentacles
                ctx.fillStyle = `rgba(100,200,255,${jGlow * 0.4})`;
                for (let i = 0; i < 4; i++) {
                    const tx2 = x + 2 + i * 3; const ty2 = y + 7 + jb;
                    ctx.fillRect(tx2 + Math.sin(time / 120 + i) * 1, ty2, 1, 4 + Math.sin(time / 150 + i) * 2);
                }
                // Glow
                ctx.fillStyle = `rgba(200,255,255,${jGlow * 0.3})`;
                ctx.fillRect(x + 3, y + 3 + jb, 3, 2); break;
            }
            case 'MIMIC': {
                const mOpen = Math.sin(time / 150 + m.id) * 0.3 + 0.5;
                // Chest body
                ctx.fillStyle = flash ? '#fff' : '#8a6a30';
                ctx.fillRect(x + 1, y + 2, w - 2, h - 4);
                ctx.fillStyle = flash ? '#ddd' : '#7a5a20';
                ctx.fillRect(x + 2, y + 3, w - 4, h - 6);
                // Lid (opens to attack)
                ctx.fillStyle = flash ? '#ee8' : '#aa8040';
                ctx.fillRect(x + 1, y + 2 - mOpen * 4, w - 2, 4);
                // Teeth
                ctx.fillStyle = '#fff';
                for (let i = 0; i < 5; i++) {
                    ctx.fillRect(x + 2 + i * 2, y + 5 - mOpen * 3, 1, 2 + mOpen * 2);
                }
                // Eye
                ctx.fillStyle = '#ff0'; ctx.fillRect(x + 4, y + 4 - mOpen * 2, 3, 2);
                ctx.fillStyle = '#f00'; ctx.fillRect(x + 5, y + 4 - mOpen * 2, 1, 2);
                // Legs
                ctx.fillStyle = '#6a4a20';
                ctx.fillRect(x + 2, y + h - 3, 3, 3 + walk * 0.4); ctx.fillRect(x + w - 5, y + h - 3, 3, 3 - walk * 0.4);
                // Gold lock
                ctx.fillStyle = '#ffd700'; ctx.fillRect(x + w / 2 - 1, y + 7, 3, 3); break;
            }
            case 'IMP': {
                const impF = Math.sin(time / 100 + m.id) * 2;
                // Body
                ctx.fillStyle = flash ? '#fcc' : '#cc3333';
                ctx.fillRect(x + 2, y + 3, w - 4, h - 5);
                // Wings (small)
                ctx.fillStyle = '#aa2222';
                ctx.fillRect(x - 2, y + 3 + impF * 0.3, 4, 4); ctx.fillRect(x + w - 2, y + 3 - impF * 0.3, 4, 4);
                // Head
                ctx.fillStyle = '#dd4444'; ctx.fillRect(x + 2, y, w - 4, 5);
                // Horns
                ctx.fillStyle = '#881111'; ctx.fillRect(x + 1, y - 2, 2, 3); ctx.fillRect(x + w - 3, y - 2, 2, 3);
                // Eyes
                ctx.fillStyle = '#ff8800'; ctx.fillRect(x + 3, y + 2, 2, 1); ctx.fillRect(x + w - 5, y + 2, 2, 1);
                // Fireball
                if (Math.sin(time / 300 + m.id * 3) > 0.5) {
                    ctx.fillStyle = '#ffaa00'; ctx.fillRect(x + w, y + 5 + impF, 4, 3);
                    ctx.fillStyle = '#ff6600'; ctx.fillRect(x + w + 1, y + 6 + impF, 2, 1);
                }
                break;
            }
            case 'TEMPLE_GUARD': {
                // Stone body
                ctx.fillStyle = flash ? '#ddd' : '#7a7a60';
                ctx.fillRect(x + 2, y + 6, w - 4, h - 10);
                ctx.fillStyle = flash ? '#ccc' : '#6a6a50';
                ctx.fillRect(x + 3, y + 8, w - 6, h - 14);
                // Legs
                ctx.fillRect(x + 3, y + h - 5, 3, 5 + walk * 0.3); ctx.fillRect(x + w - 6, y + h - 5, 3, 5 - walk * 0.3);
                // Head (mask)
                ctx.fillStyle = flash ? '#eee' : '#8a8a70';
                ctx.fillRect(x + 2, y, w - 4, 8);
                // Golden mask details
                ctx.fillStyle = '#ddb700';
                ctx.fillRect(x + 3, y + 1, w - 6, 2);
                ctx.fillRect(x + w / 2 - 1, y + 3, 2, 3);
                // Glowing eyes
                const grd = Math.sin(time / 200 + m.id) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(0,255,100,${grd})`;
                ctx.fillRect(x + 4, y + 3, 2, 2); ctx.fillRect(x + w - 6, y + 3, 2, 2);
                // Spear
                ctx.fillStyle = '#6a5a3a'; ctx.fillRect(x + w - 1, y + 4, 2, h - 8);
                ctx.fillStyle = '#aaa'; ctx.fillRect(x + w - 2, y + 2, 4, 3); break;
            }
            case 'SLIME_KING': {
                const skBounce = m.ground ? 0 : Math.abs(m.vy) * 0.3;
                const skPulse = Math.sin(time / 200 + m.id) * 0.2 + 0.8;
                // Giant body
                ctx.fillStyle = flash ? '#fff' : '#44aa44';
                ctx.fillRect(x + 2, y + h - 20 - skBounce, w - 4, 20 + skBounce);
                ctx.fillStyle = flash ? '#efe' : '#55cc55';
                ctx.fillRect(x + 3, y + h - 19 - skBounce, w - 6, 18 + skBounce);
                // Crown!
                ctx.fillStyle = '#ffd700';
                ctx.fillRect(x + 6, y + h - 22 - skBounce, w - 12, 3);
                ctx.fillRect(x + 7, y + h - 25 - skBounce, 3, 4);
                ctx.fillRect(x + w / 2 - 1, y + h - 26 - skBounce, 3, 5);
                ctx.fillRect(x + w - 10, y + h - 25 - skBounce, 3, 4);
                // Jewels on crown
                ctx.fillStyle = '#ff2244'; ctx.fillRect(x + 8, y + h - 24 - skBounce, 1, 1);
                ctx.fillStyle = '#4488ff'; ctx.fillRect(x + w / 2, y + h - 25 - skBounce, 1, 1);
                ctx.fillStyle = '#ff2244'; ctx.fillRect(x + w - 9, y + h - 24 - skBounce, 1, 1);
                // Shine
                ctx.fillStyle = `rgba(255,255,255,${skPulse * 0.4})`;
                ctx.fillRect(x + 5, y + h - 18 - skBounce, 8, 5);
                // Eyes
                ctx.fillStyle = '#fff';
                ctx.fillRect(x + 6, y + h - 16 - skBounce, 4, 4); ctx.fillRect(x + w - 10, y + h - 16 - skBounce, 4, 4);
                ctx.fillStyle = '#111';
                ctx.fillRect(x + 7, y + h - 15 - skBounce, 2, 3); ctx.fillRect(x + w - 9, y + h - 15 - skBounce, 2, 3);
                // Inner slimes visible inside
                ctx.fillStyle = 'rgba(100,200,100,0.4)';
                ctx.fillRect(x + 6, y + h - 10 - skBounce, 5, 4);
                ctx.fillRect(x + w - 11, y + h - 8 - skBounce, 4, 3); break;
            }
            // === NEW BIOME MOBS ===
            case 'PRISM_ELEMENTAL': {
                const pe = Math.sin(time / 200 + m.id * 2) * 3;
                ctx.fillStyle = flash ? '#fff' : `rgba(140,170,255,${0.7 + Math.sin(time / 300) * 0.2})`;
                ctx.fillRect(x + 2, y + 2 + pe, w - 4, h - 4);
                ctx.fillStyle = `rgba(200,220,255,${0.5 + Math.sin(time / 150 + m.id) * 0.3})`;
                ctx.fillRect(x + 4, y + 4 + pe, w - 8, h - 8);
                // Crystal points
                ctx.fillStyle = '#aaccff';
                ctx.fillRect(x + w / 2 - 1, y + pe, 2, 4);
                ctx.fillRect(x + w / 2 - 1, y + h - 4 + pe, 2, 4);
                ctx.fillRect(x, y + h / 2 - 1 + pe, 4, 2);
                ctx.fillRect(x + w - 4, y + h / 2 - 1 + pe, 4, 2);
                // Eye
                ctx.fillStyle = '#fff'; ctx.fillRect(x + w / 2 - 2, y + h / 2 - 2 + pe, 4, 3);
                ctx.fillStyle = '#4466ff'; ctx.fillRect(x + w / 2 - 1, y + h / 2 - 1 + pe, 2, 2); break;
            }
            case 'ANGLER_FISH': {
                const af = Math.sin(time / 250 + m.id) * 2;
                ctx.fillStyle = flash ? '#fff' : '#1a2a3a';
                ctx.fillRect(x + 2, y + 2 + af, w - 4, h - 3);
                // Body
                ctx.fillStyle = '#0a1a2a'; ctx.fillRect(x + 3, y + 3 + af, w - 6, h - 5);
                // Lure light
                const lg = Math.sin(time / 100 + m.id * 3) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(100,255,200,${lg})`; ctx.fillRect(x + 1, y - 2 + af, 3, 3);
                ctx.fillStyle = `rgba(100,255,200,${lg * 0.4})`; ctx.fillRect(x - 1, y - 4 + af, 7, 7);
                // Jaw
                ctx.fillStyle = '#2a3a4a'; ctx.fillRect(x + w - 5, y + h - 4 + af, 5, 2);
                // Eye
                ctx.fillStyle = '#44ffcc'; ctx.fillRect(x + 4, y + 3 + af, 2, 2);
                // Teeth
                ctx.fillStyle = '#ddd';
                for (let i = 0; i < 3; i++) ctx.fillRect(x + w - 4 + i * 2, y + h - 2 + af, 1, 1); break;
            }
            case 'ASH_WRAITH': {
                const aw = Math.sin(time / 180 + m.id) * 4;
                ctx.globalAlpha = 0.7 + Math.sin(time / 200) * 0.2;
                ctx.fillStyle = flash ? '#fff' : '#cc6633';
                ctx.fillRect(x + 3, y + 2 + aw, w - 6, h - 4);
                ctx.fillStyle = '#ff8844'; ctx.fillRect(x + 4, y + 4 + aw, w - 8, h - 8);
                // Fire crown
                const fc = Math.sin(time / 80 + m.id * 2) * 2;
                ctx.fillStyle = '#ff4400'; ctx.fillRect(x + 3, y + fc, w - 6, 4);
                ctx.fillStyle = '#ffaa00'; ctx.fillRect(x + 5, y - 2 + fc, 2, 3);
                ctx.fillRect(x + w - 7, y - 1 + fc, 2, 2);
                // Eyes
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 4, y + 6 + aw, 3, 2); ctx.fillRect(x + w - 7, y + 6 + aw, 3, 2);
                ctx.fillStyle = '#ff2200'; ctx.fillRect(x + 5, y + 6 + aw, 1, 2); ctx.fillRect(x + w - 6, y + 6 + aw, 1, 2);
                ctx.globalAlpha = 1; break;
            }
            case 'VINE_GOLEM': {
                // Body
                ctx.fillStyle = flash ? '#fff' : '#4a6a3a';
                ctx.fillRect(x + 2, y + 4 + walk, w - 4, h - 6);
                ctx.fillStyle = '#3a5a2a'; ctx.fillRect(x + 3, y + 5 + walk, w - 6, h - 8);
                // Vine overlay
                ctx.fillStyle = '#2a8a2a';
                for (let i = 0; i < 4; i++) ctx.fillRect(x + (m.id * 3 + i * 5) % (w - 6) + 2, y + 6 + i * 5 + walk, 2, 4);
                // Head
                ctx.fillStyle = '#5a7a4a'; ctx.fillRect(x + 4, y + 2 + walk, w - 8, 6);
                // Eyes
                ctx.fillStyle = '#88ff44'; ctx.fillRect(x + 5, y + 3 + walk, 3, 3); ctx.fillRect(x + w - 8, y + 3 + walk, 3, 3);
                ctx.fillStyle = '#115500'; ctx.fillRect(x + 6, y + 4 + walk, 1, 2); ctx.fillRect(x + w - 7, y + 4 + walk, 1, 2);
                // Legs
                ctx.fillStyle = '#4a6a3a';
                ctx.fillRect(x + 3, y + h - 4, 4, 4 + walk); ctx.fillRect(x + w - 7, y + h - 4, 4, 4 + walk); break;
            }
            case 'BLOOD_ZOMBIE': {
                // Body
                ctx.fillStyle = flash ? '#fff' : '#5a1a1a';
                ctx.fillRect(x + 3, y + 4 + walk, w - 6, h - 8);
                // Shirt
                ctx.fillStyle = '#8a2222'; ctx.fillRect(x + 3, y + 6 + walk, w - 6, 8);
                // Head
                ctx.fillStyle = '#7a3030'; ctx.fillRect(x + 3, y + 1 + walk, w - 6, 6);
                // Eyes (glowing red)
                const bg = Math.sin(time / 150 + m.id * 2) * 0.2 + 0.8;
                ctx.fillStyle = `rgba(255,50,50,${bg})`; ctx.fillRect(x + 4, y + 3 + walk, 2, 2); ctx.fillRect(x + w - 6, y + 3 + walk, 2, 2);
                // Blood drips
                ctx.fillStyle = '#cc2222';
                ctx.fillRect(x + 5, y + 7 + walk, 1, 3);
                ctx.fillRect(x + w - 6, y + 8 + walk, 1, 2);
                // Arms + Legs
                ctx.fillStyle = '#5a1a1a';
                ctx.fillRect(x + 1, y + 6 + walk, 2, 10); ctx.fillRect(x + w - 3, y + 7 + walk, 2, 9);
                ctx.fillRect(x + 3, y + h - 4, 3, 4 + walk); ctx.fillRect(x + w - 6, y + h - 4, 3, 4 + walk); break;
            }
            case 'PHANTOM': {
                const ph = Math.sin(time / 200 + m.id) * 5;
                ctx.globalAlpha = 0.5 + Math.sin(time / 300 + m.id * 2) * 0.2;
                ctx.fillStyle = flash ? '#fff' : '#aabbcc';
                ctx.fillRect(x + 2, y + 2 + ph, w - 4, h - 4);
                ctx.fillStyle = '#8899aa'; ctx.fillRect(x + 3, y + 3 + ph, w - 6, h - 6);
                // Wispy bottom
                ctx.fillStyle = 'rgba(150,170,190,0.4)';
                ctx.fillRect(x + 1, y + h - 4 + ph, 3, 4); ctx.fillRect(x + w - 4, y + h - 3 + ph, 3, 3);
                // Eyes  
                ctx.globalAlpha = 0.9;
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 3, y + 5 + ph, 3, 3); ctx.fillRect(x + w - 6, y + 5 + ph, 3, 3);
                ctx.fillStyle = '#111'; ctx.fillRect(x + 4, y + 6 + ph, 1, 2); ctx.fillRect(x + w - 5, y + 6 + ph, 1, 2);
                ctx.globalAlpha = 1; break;
            }
            case 'SHIMMER_SPRITE': {
                const ss = Math.sin(time / 150 + m.id * 3) * 3;
                const sg = Math.sin(time / 200 + m.id) * 0.3 + 0.7;
                ctx.fillStyle = flash ? '#fff' : `rgba(170,220,255,${sg})`;
                ctx.fillRect(x + 1, y + 1 + ss, w - 2, h - 2);
                // Wings
                ctx.fillStyle = `rgba(200,240,255,${sg * 0.5})`;
                const wf = Math.sin(time / 100 + m.id * 2) * 2;
                ctx.fillRect(x - 3 - wf, y + 2 + ss, 4, 3); ctx.fillRect(x + w - 1 + wf, y + 2 + ss, 4, 3);
                // Core glow
                ctx.fillStyle = `rgba(255,255,255,${sg * 0.8})`; ctx.fillRect(x + 2, y + 2 + ss, 4, 4);
                // Sparkle trail
                ctx.fillStyle = `rgba(200,240,255,${sg * 0.3})`;
                ctx.fillRect(x + 2, y + h + ss, 1, 2); ctx.fillRect(x + w - 3, y + h + 1 + ss, 1, 2); break;
            }
            case 'RUIN_SENTINEL': {
                // Body - stone
                ctx.fillStyle = flash ? '#fff' : '#5a6a4a';
                ctx.fillRect(x + 2, y + 4 + walk, w - 4, h - 6);
                ctx.fillStyle = '#4a5a3a'; ctx.fillRect(x + 3, y + 5 + walk, w - 6, h - 8);
                // Mossy patches
                ctx.fillStyle = '#3a7a2a';
                ctx.fillRect(x + 4, y + 8 + walk, 4, 3); ctx.fillRect(x + w - 8, y + 12 + walk, 3, 3);
                // Head
                ctx.fillStyle = '#6a7a5a'; ctx.fillRect(x + 3, y + 1 + walk, w - 6, 6);
                // Eyes (green glow)
                const rg = Math.sin(time / 200 + m.id) * 0.2 + 0.8;
                ctx.fillStyle = `rgba(100,255,80,${rg})`; ctx.fillRect(x + 5, y + 3 + walk, 2, 2); ctx.fillRect(x + w - 7, y + 3 + walk, 2, 2);
                // Arms + Legs
                ctx.fillStyle = '#5a6a4a';
                ctx.fillRect(x, y + 6 + walk, 3, 12); ctx.fillRect(x + w - 3, y + 7 + walk, 3, 11);
                ctx.fillRect(x + 3, y + h - 4, 4, 4 + walk); ctx.fillRect(x + w - 7, y + h - 4, 4, 4 + walk); break;
            }
            // === PHASE 3: NEW BIOME MOBS ===
            case 'SPORELING': {
                const spBounce = m.ground ? 0 : Math.abs(m.vy) * 0.25;
                const spPulse = Math.sin(time / 200 + m.id * 3) * 0.2 + 0.8;
                // Body (mushroom-like blob)
                ctx.fillStyle = flash ? '#fff' : `rgb(${140 + spPulse * 40 | 0},${40 + spPulse * 20 | 0},${160 + spPulse * 40 | 0})`;
                ctx.fillRect(x + 1, y + h - 8 - spBounce, w - 2, 8 + spBounce);
                ctx.fillStyle = flash ? '#fdf' : `rgb(${180 + spPulse * 30 | 0},${60 + spPulse * 20 | 0},${180 + spPulse * 30 | 0})`;
                ctx.fillRect(x + 2, y + h - 7 - spBounce, w - 4, 6 + spBounce);
                // Cap
                ctx.fillStyle = `rgb(${200 + spPulse * 30 | 0},${50 + spPulse * 20 | 0},${160 + spPulse * 30 | 0})`;
                ctx.fillRect(x, y + h - 10 - spBounce, w, 4);
                // Spots
                ctx.fillStyle = '#fff';
                ctx.fillRect(x + 2, y + h - 9 - spBounce, 2, 2);
                ctx.fillRect(x + w - 4, y + h - 9 - spBounce, 2, 2);
                // Eyes
                ctx.fillStyle = '#ff88ff'; ctx.fillRect(x + 2, y + h - 6 - spBounce, 2, 2);
                ctx.fillRect(x + w - 4, y + h - 6 - spBounce, 2, 2);
                ctx.fillStyle = '#220022'; ctx.fillRect(x + 3, y + h - 5 - spBounce, 1, 1);
                ctx.fillRect(x + w - 3, y + h - 5 - spBounce, 1, 1);
                // Spore particles
                ctx.fillStyle = `rgba(200,80,255,${spPulse * 0.4})`;
                ctx.fillRect(x + Math.sin(time / 100 + m.id) * 3, y + h - 12 - spBounce, 1, 1);
                ctx.fillRect(x + w - 2 + Math.sin(time / 130 + m.id) * 2, y + h - 11 - spBounce, 1, 1);
                break;
            }
            case 'MYCELIUM_HORROR': {
                const mhPulse = Math.sin(time / 300 + m.id) * 3;
                // Main body mass
                ctx.fillStyle = flash ? '#fff' : '#4a1a5a';
                ctx.fillRect(x + 3, y + 6 + mhPulse * 0.3, w - 6, h - 8);
                ctx.fillStyle = '#3a0a4a';
                ctx.fillRect(x + 4, y + 7 + mhPulse * 0.3, w - 8, h - 10);
                // Tentacles
                for (let i = 0; i < 4; i++) {
                    const tx2 = Math.sin(time / 150 + i * 1.5 + m.id) * 4;
                    ctx.fillStyle = `rgba(150,40,180,${0.7 - i * 0.1})`;
                    ctx.fillRect(x - 4 + i * 2 + tx2, y + h - 4 + i * 2, 3, 6 + i);
                    ctx.fillRect(x + w - 2 + i * 2 - tx2, y + h - 3 + i * 2, 3, 5 + i);
                }
                // Head/cap
                ctx.fillStyle = flash ? '#fdf' : '#cc44aa';
                ctx.fillRect(x + 2, y + 2 + mhPulse * 0.2, w - 4, 8);
                ctx.fillStyle = '#ff66cc';
                ctx.fillRect(x + 5, y + 3 + mhPulse * 0.2, 4, 3);
                ctx.fillRect(x + w - 9, y + 4 + mhPulse * 0.2, 4, 3);
                // Many eyes
                const eg = Math.sin(time / 200 + m.id * 2) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(255,100,200,${eg})`;
                ctx.fillRect(x + 5, y + 10 + mhPulse * 0.3, 3, 3);
                ctx.fillRect(x + w - 8, y + 10 + mhPulse * 0.3, 3, 3);
                ctx.fillRect(x + w / 2 - 1, y + 8 + mhPulse * 0.3, 2, 2);
                ctx.fillStyle = '#110011';
                ctx.fillRect(x + 6, y + 11 + mhPulse * 0.3, 1, 2);
                ctx.fillRect(x + w - 7, y + 11 + mhPulse * 0.3, 1, 2);
                // Legs
                ctx.fillStyle = '#4a1a5a';
                ctx.fillRect(x + 4, y + h - 4, 4, 4 + walk); ctx.fillRect(x + w - 8, y + h - 4, 4, 4 + walk);
                break;
            }
            case 'CHRONOLISK': {
                const clPhase = Math.sin(time / 180 + m.id * 2);
                // Time distortion aura — drawn BEHIND body, subtle glow
                const auraAlpha = 0.08 + Math.abs(clPhase) * 0.07;
                ctx.fillStyle = `rgba(220,180,60,${auraAlpha})`;
                ctx.fillRect(x - 4, y - 2, w + 8, h + 4);
                ctx.fillStyle = `rgba(255,220,80,${auraAlpha * 0.5})`;
                ctx.fillRect(x - 2, y, w + 4, h + 2);
                // Temporal sparkles around body
                for (let ti = 0; ti < 3; ti++) {
                    const tsx = x + Math.sin(time / 120 + ti * 2.1 + m.id) * (w * 0.8);
                    const tsy = y + h / 2 + Math.cos(time / 150 + ti * 1.7 + m.id) * (h * 0.6);
                    ctx.fillStyle = `rgba(255,230,100,${0.3 + Math.sin(time / 100 + ti) * 0.2})`;
                    ctx.fillRect(tsx, tsy, 1, 1);
                }
                // Body — lizard/raptor shape
                ctx.fillStyle = flash ? '#fff' : '#8a7a50';
                ctx.fillRect(x + 2, y + 4 + walk, w - 4, h - 7);
                ctx.fillStyle = '#7a6a40';
                ctx.fillRect(x + 3, y + 5 + walk, w - 6, h - 9);
                // Head
                ctx.fillStyle = '#9a8a60';
                ctx.fillRect(x + w - 6, y + 2 + walk, 7, 6);
                // Crest
                ctx.fillStyle = '#ddaa44';
                ctx.fillRect(x + w - 4, y + walk, 3, 3);
                ctx.fillRect(x + w - 3, y - 1 + walk, 2, 2);
                // Eyes (golden, glowing)
                const ceg = Math.sin(time / 150 + m.id) * 0.2 + 0.8;
                ctx.fillStyle = `rgba(255,220,60,${ceg})`;
                ctx.fillRect(x + w - 3, y + 3 + walk, 2, 2);
                ctx.fillStyle = '#332200';
                ctx.fillRect(x + w - 2, y + 4 + walk, 1, 1);
                // Legs
                ctx.fillStyle = '#7a6a40';
                ctx.fillRect(x + 3, y + h - 4, 3, 4 + walk * 0.5);
                ctx.fillRect(x + w - 6, y + h - 4, 3, 4 - walk * 0.5);
                // Tail
                ctx.fillStyle = '#8a7a50';
                ctx.fillRect(x - 2, y + 6 + walk, 4, 3);
                ctx.fillRect(x - 4, y + 7 + walk, 3, 2);
                break;
            }
            case 'PETRIFIER': {
                // Heavy stone golem with petrifying gaze
                ctx.fillStyle = flash ? '#ddd' : '#6a6050';
                ctx.fillRect(x + 2, y + 4 + walk, w - 4, h - 6);
                ctx.fillStyle = '#5a5040';
                ctx.fillRect(x + 3, y + 5 + walk, w - 6, h - 8);
                // Cracks
                ctx.fillStyle = '#4a4030';
                ctx.fillRect(x + 5, y + 7, 1, 6); ctx.fillRect(x + w - 6, y + 9, 1, 5);
                // Head
                ctx.fillStyle = '#7a7060';
                ctx.fillRect(x + 3, y + 1 + walk, w - 6, 6);
                // Eyes (petrifying glow)
                const peg = Math.sin(time / 250 + m.id) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(200,200,100,${peg})`;
                ctx.fillRect(x + 5, y + 3 + walk, 2, 2);
                ctx.fillRect(x + w - 7, y + 3 + walk, 2, 2);
                // Gaze beam (subtle)
                if (peg > 0.8) {
                    ctx.fillStyle = `rgba(200,200,100,${(peg - 0.8) * 2})`;
                    ctx.fillRect(x + w / 2 - 1, y + 5 + walk, 2, 4);
                }
                // Legs (thick)
                ctx.fillStyle = '#5a5040';
                ctx.fillRect(x + 3, y + h - 4, 5, 4 + walk * 0.3);
                ctx.fillRect(x + w - 8, y + h - 4, 5, 4 - walk * 0.3);
                // Arms
                ctx.fillRect(x - 1, y + 6 + walk, 3, 8);
                ctx.fillRect(x + w - 2, y + 7 + walk, 3, 7);
                break;
            }
            case 'PRISM_CRAB': {
                const pcPhase = time / 300 + m.id;
                const pr = 180 + Math.sin(pcPhase) * 60 | 0;
                const pg = 180 + Math.sin(pcPhase + 2.1) * 60 | 0;
                const pb = 180 + Math.sin(pcPhase + 4.2) * 60 | 0;
                // Shell (rainbow shifting)
                ctx.fillStyle = flash ? '#fff' : `rgb(${pr},${pg},${pb})`;
                ctx.fillRect(x + 2, y + 1, w - 4, h - 3);
                ctx.fillStyle = `rgb(${pr + 30},${pg + 30},${pb + 30})`;
                ctx.fillRect(x + 3, y + 2, w - 6, h - 5);
                // Legs
                ctx.fillStyle = `rgb(${pr - 40},${pg - 40},${pb - 40})`;
                for (let i = 0; i < 3; i++) {
                    ctx.fillRect(x - 1, y + 2 + i * 2, 3, 1);
                    ctx.fillRect(x + w - 2, y + 2 + i * 2, 3, 1);
                }
                // Claws (crystal)
                ctx.fillStyle = `rgb(${pr + 50},${pg + 50},${pb + 50})`;
                ctx.fillRect(x - 3, y, 4, 3); ctx.fillRect(x + w - 1, y, 4, 3);
                ctx.fillRect(x - 4, y, 2, 2); ctx.fillRect(x + w + 1, y, 2, 2);
                // Eyes
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 3, y - 1, 2, 2);
                ctx.fillRect(x + w - 5, y - 1, 2, 2);
                ctx.fillStyle = '#111'; ctx.fillRect(x + 4, y, 1, 1);
                ctx.fillRect(x + w - 4, y, 1, 1);
                // Prismatic sparkle
                ctx.fillStyle = `rgba(255,255,255,${0.3 + Math.sin(time / 100 + m.id) * 0.2})`;
                ctx.fillRect(x + 4, y + 2, 2, 1);
                break;
            }
            case 'LIGHT_WEAVER': {
                const lwPhase = time / 250 + m.id;
                const lwFloat = Math.sin(time / 200 + m.id * 2) * 3;
                // Body — ethereal, geometric
                const lr = 180 + Math.sin(lwPhase) * 50 | 0;
                const lg = 220 + Math.sin(lwPhase + 2) * 30 | 0;
                const lb = 240 + Math.sin(lwPhase + 4) * 15 | 0;
                ctx.fillStyle = flash ? '#fff' : `rgba(${lr},${lg},${lb},0.8)`;
                ctx.fillRect(x + 2, y + 2 + lwFloat, w - 4, h - 4);
                ctx.fillStyle = `rgba(${lr + 30},${lg + 20},${lb + 10},0.6)`;
                ctx.fillRect(x + 3, y + 3 + lwFloat, w - 6, h - 6);
                // Wings of light
                const wf = Math.sin(time / 80 + m.id) * 3;
                ctx.fillStyle = `rgba(255,255,220,0.4)`;
                ctx.fillRect(x - 4 - wf, y + 3 + lwFloat, 5, 4);
                ctx.fillRect(x + w - 1 + wf, y + 3 + lwFloat, 5, 4);
                // Core
                ctx.fillStyle = `rgba(255,255,255,${0.6 + Math.sin(time / 150 + m.id) * 0.3})`;
                ctx.fillRect(x + w / 2 - 1, y + h / 2 - 1 + lwFloat, 3, 3);
                // Light beams (occasionally)
                if (Math.sin(time / 400 + m.id * 3) > 0.3) {
                    ctx.fillStyle = `rgba(255,255,200,0.2)`;
                    ctx.fillRect(x + w / 2 - 1, y + h + lwFloat, 2, 6);
                }
                break;
            }
            case 'TIDE_CRAWLER': {
                // Giant crab with barnacle-encrusted shell
                ctx.fillStyle = flash ? '#ddd' : '#5a7a6a';
                ctx.fillRect(x + 3, y + 2, w - 6, h - 4);
                ctx.fillStyle = flash ? '#ccc' : '#4a6a5a';
                ctx.fillRect(x + 4, y + 3, w - 8, h - 6);
                // Barnacles on shell
                ctx.fillStyle = '#8a9a8a';
                ctx.fillRect(x + 5, y + 3, 3, 2); ctx.fillRect(x + 11, y + 4, 2, 2);
                // Legs
                ctx.fillStyle = '#4a6a5a';
                for (let i = 0; i < 4; i++) {
                    ctx.fillRect(x - 2, y + 2 + i * 2, 4, 1);
                    ctx.fillRect(x + w - 2, y + 2 + i * 2, 4, 1);
                }
                // Giant claws
                ctx.fillStyle = flash ? '#eee' : '#6a8a7a';
                ctx.fillRect(x - 5, y, 6, 4); ctx.fillRect(x + w - 1, y, 6, 4);
                ctx.fillRect(x - 6, y, 3, 2); ctx.fillRect(x + w + 2, y, 3, 2);
                // Eyes on stalks
                ctx.fillStyle = '#222'; ctx.fillRect(x + w - 6, y - 2, 2, 3); ctx.fillRect(x + w - 3, y - 2, 2, 3);
                ctx.fillStyle = '#4af'; ctx.fillRect(x + w - 5, y - 2, 1, 1); ctx.fillRect(x + w - 2, y - 2, 1, 1);
                break;
            }
            case 'SIREN': {
                const sirFloat = Math.sin(time / 200 + m.id * 2) * 3;
                const sirPhase = time / 350 + m.id;
                // Ethereal body
                ctx.fillStyle = flash ? '#fff' : `rgba(80,180,200,0.8)`;
                ctx.fillRect(x + 2, y + 2 + sirFloat, w - 4, h - 4);
                ctx.fillStyle = `rgba(120,220,240,0.6)`;
                ctx.fillRect(x + 3, y + 3 + sirFloat, w - 6, h - 6);
                // Flowing hair
                const hairWave = Math.sin(time / 150 + m.id) * 2;
                ctx.fillStyle = `rgba(60,200,180,0.7)`;
                ctx.fillRect(x + 1 + hairWave, y - 2 + sirFloat, 3, 5);
                ctx.fillRect(x + w - 4 + hairWave * 0.5, y - 1 + sirFloat, 3, 4);
                // Eyes (hypnotic glow)
                const sirGlow = Math.sin(sirPhase) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(100,255,220,${sirGlow})`;
                ctx.fillRect(x + 3, y + 4 + sirFloat, 2, 2);
                ctx.fillRect(x + w - 5, y + 4 + sirFloat, 2, 2);
                // Song waves (visual)
                if (sirGlow > 0.8) {
                    ctx.fillStyle = `rgba(100,220,200,${(sirGlow - 0.8) * 2})`;
                    ctx.fillRect(x + w / 2 - 1, y + h + sirFloat, 2, 3);
                }
                break;
            }
            case 'HERMIT_CRAB': {
                // Small with shell on back
                ctx.fillStyle = flash ? '#fcc' : '#cc7744';
                ctx.fillRect(x + 1, y + 3, w - 2, h - 4);
                // Shell
                ctx.fillStyle = flash ? '#eee' : '#aabb99';
                ctx.fillRect(x + 1, y + 1, w - 4, h - 4);
                ctx.fillStyle = '#99aa88'; ctx.fillRect(x + 2, y + 2, 3, 3);
                // Legs
                ctx.fillStyle = '#bb6633';
                ctx.fillRect(x - 1, y + 4, 2, 1); ctx.fillRect(x - 1, y + 6, 2, 1);
                ctx.fillRect(x + w - 1, y + 4, 2, 1); ctx.fillRect(x + w - 1, y + 6, 2, 1);
                // Eye
                ctx.fillStyle = '#111'; ctx.fillRect(x + w - 3, y + 2, 1, 1);
                break;
            }
            case 'STORM_ELEMENTAL': {
                const seFloat = Math.sin(time / 150 + m.id * 2) * 3;
                const sePhase = time / 200 + m.id;
                // Crackling energy body
                const sr = 100 + Math.sin(sePhase) * 40 | 0;
                const sg = 160 + Math.sin(sePhase + 1) * 40 | 0;
                const sb = 220 + Math.sin(sePhase + 2) * 35 | 0;
                ctx.fillStyle = flash ? '#fff' : `rgb(${sr},${sg},${sb})`;
                ctx.fillRect(x + 2, y + 2 + seFloat, w - 4, h - 4);
                ctx.fillStyle = `rgba(${sr + 40},${sg + 30},${sb + 20},0.6)`;
                ctx.fillRect(x + 3, y + 3 + seFloat, w - 6, h - 6);
                // Lightning bolts emanating
                const bolt = Math.sin(time / 80 + m.id * 3);
                if (bolt > 0.3) {
                    ctx.fillStyle = '#fff';
                    ctx.fillRect(x + w / 2 + bolt * 3, y - 3 + seFloat, 1, 5);
                    ctx.fillRect(x + w / 2 + bolt * 3 + 1, y - 1 + seFloat, 1, 3);
                }
                // Core
                ctx.fillStyle = `rgba(255,255,255,${0.5 + Math.sin(time / 100) * 0.3})`;
                ctx.fillRect(x + w / 2 - 2, y + h / 2 - 2 + seFloat, 4, 4);
                // Electric sparks around
                ctx.fillStyle = `rgba(200,230,255,${0.4 + bolt * 0.3})`;
                ctx.fillRect(x - 2 + Math.floor(bolt * 3), y + 4 + seFloat, 2, 1);
                ctx.fillRect(x + w + Math.floor(bolt * -2), y + 6 + seFloat, 2, 1);
                break;
            }
            case 'THUNDER_GOAT': {
                // Muscular mountain goat with electric horns
                ctx.fillStyle = flash ? '#ddd' : '#7a7a8a';
                ctx.fillRect(x + 3, y + 2, w - 6, h - 5);
                ctx.fillStyle = flash ? '#ccc' : '#6a6a7a';
                ctx.fillRect(x + 4, y + 3, w - 8, h - 7);
                // Legs (strong)
                ctx.fillStyle = '#5a5a6a';
                ctx.fillRect(x + 3, y + h - 4, 3, 4 + walk * 0.6);
                ctx.fillRect(x + w - 6, y + h - 4, 3, 4 - walk * 0.6);
                // Head
                ctx.fillStyle = flash ? '#eee' : '#8a8a9a';
                ctx.fillRect(x + w - 5, y, 5, 5);
                // Electric horns
                const hGlow = Math.sin(time / 200 + m.id) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(140,200,255,${hGlow})`;
                ctx.fillRect(x + w - 4, y - 3, 2, 4);
                ctx.fillRect(x + w - 2, y - 4, 2, 3);
                // Sparks from horns
                if (hGlow > 0.8) {
                    ctx.fillStyle = '#fff';
                    ctx.fillRect(x + w - 3, y - 5, 1, 1);
                }
                // Eyes
                ctx.fillStyle = `rgba(140,200,255,${hGlow})`;
                ctx.fillRect(x + w - 3, y + 2, 2, 1);
                break;
            }
            case 'STORM_HAWK': {
                const shFloat = Math.sin(time / 120 + m.id * 2) * 2;
                const wingFlap = Math.sin(time / 80 + m.id) * 4;
                // Body
                ctx.fillStyle = flash ? '#ddd' : '#5a5a6a';
                ctx.fillRect(x + 3, y + 3 + shFloat, w - 6, h - 6);
                // Wings
                ctx.fillStyle = flash ? '#ccc' : '#4a4a5a';
                ctx.fillRect(x - 3 - wingFlap, y + 3 + shFloat, 5, 3);
                ctx.fillRect(x + w - 2 + wingFlap, y + 3 + shFloat, 5, 3);
                // Beak
                ctx.fillStyle = '#cc9933';
                ctx.fillRect(x + w - 2, y + 4 + shFloat, 3, 2);
                // Eye
                ctx.fillStyle = '#ff0';
                ctx.fillRect(x + w - 3, y + 3 + shFloat, 1, 1);
                break;
            }
            case 'NERVE_WORM': {
                // Organic worm with visible nerve strands
                const nwPulse = Math.sin(time / 300 + m.id) * 0.2 + 0.8;
                // Head
                ctx.fillStyle = flash ? '#faa' : `rgba(200,80,80,${nwPulse})`;
                ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                ctx.fillStyle = `rgba(220,100,100,${nwPulse * 0.7})`;
                ctx.fillRect(x + 3, y + 3, w - 6, h - 6);
                // Eyes
                ctx.fillStyle = '#fff';
                ctx.fillRect(x + w - 4, y + 4, 2, 2);
                ctx.fillStyle = '#200';
                ctx.fillRect(x + w - 3, y + 5, 1, 1);
                // Mouth
                ctx.fillStyle = '#400';
                ctx.fillRect(x + w - 2, y + h / 2 - 1, 2, 3);
                // Segments
                if (m.segments) {
                    for (let si = 0; si < m.segments.length; si++) {
                        const seg = m.segments[si];
                        const segPulse = Math.sin(time / 300 + m.id + si * 0.5) * 0.2 + 0.8;
                        const segSz = Math.max(4, w - 4 - si);
                        ctx.fillStyle = `rgba(${180 - si * 8},${60 + si * 3},${60 + si * 3},${segPulse})`;
                        ctx.fillRect(seg.x - segSz / 2, seg.y - segSz / 2, segSz, segSz);
                        // Nerve strands on segments
                        ctx.fillStyle = `rgba(255,120,130,${segPulse * 0.4})`;
                        ctx.fillRect(seg.x - 1, seg.y - segSz / 2 - 1, 2, 2);
                    }
                }
                break;
            }
            case 'ANTIBODY': {
                // Small white blood cell-like blob
                const abPulse = Math.sin(time / 200 + m.id * 3) * 0.2 + 0.8;
                ctx.fillStyle = flash ? '#fff' : `rgba(220,200,180,${abPulse})`;
                ctx.fillRect(x + 1, y + 1, w - 2, h - 2);
                ctx.fillStyle = `rgba(240,220,200,${abPulse * 0.7})`;
                ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                // Pseudopods
                const pod1 = Math.sin(time / 150 + m.id) * 2;
                const pod2 = Math.sin(time / 180 + m.id + 2) * 2;
                ctx.fillStyle = `rgba(210,190,170,${abPulse * 0.6})`;
                ctx.fillRect(x - 1 + pod1, y + 2, 2, 3);
                ctx.fillRect(x + w - 1 + pod2, y + 3, 2, 2);
                // Nucleus
                ctx.fillStyle = `rgba(180,100,100,${abPulse})`;
                ctx.fillRect(x + w / 2 - 1, y + h / 2 - 1, 3, 3);
                break;
            }
            case 'FLESH_GOLEM': {
                // Massive stitched-together creature
                const fgPulse = Math.sin(time / 500 + m.id) * 0.1 + 0.9;
                ctx.fillStyle = flash ? '#ddd' : `rgb(${140 * fgPulse | 0},${70 * fgPulse | 0},${60 * fgPulse | 0})`;
                ctx.fillRect(x + 3, y + 6 + walk, w - 6, h - 10);
                // Stitches
                ctx.fillStyle = '#3a2020';
                ctx.fillRect(x + 5, y + 8, 1, h - 14);
                ctx.fillRect(x + w - 6, y + 10, 1, h - 16);
                for (let si = 0; si < 4; si++) {
                    ctx.fillRect(x + 4, y + 9 + si * 4, 3, 1);
                    ctx.fillRect(x + w - 7, y + 11 + si * 3, 3, 1);
                }
                // Head
                ctx.fillStyle = `rgb(${150 * fgPulse | 0},${80 * fgPulse | 0},${70 * fgPulse | 0})`;
                ctx.fillRect(x + 4, y + 1 + walk, w - 8, 7);
                // Multiple eyes (mismatched)
                ctx.fillStyle = '#ff0'; ctx.fillRect(x + 6, y + 3 + walk, 2, 2);
                ctx.fillStyle = '#f00'; ctx.fillRect(x + w - 8, y + 2 + walk, 2, 3);
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 10, y + 4 + walk, 1, 1);
                // Legs (thick, uneven)
                ctx.fillStyle = `rgb(${120 * fgPulse | 0},${60 * fgPulse | 0},${50 * fgPulse | 0})`;
                ctx.fillRect(x + 4, y + h - 5, 5, 5 + walk * 0.3);
                ctx.fillRect(x + w - 9, y + h - 5, 5, 5 - walk * 0.3);
                // Arms (asymmetric)
                ctx.fillRect(x - 2, y + 8 + walk, 4, 10);
                ctx.fillRect(x + w - 2, y + 10 + walk, 4, 8);
                break;
            }
            case 'CRACK_SPAWN': {
                // Small purple crystalline creature
                const crackPulse = Math.sin(time / 200 + m.id * 2) * 0.2 + 0.8;
                ctx.fillStyle = flash ? '#fff' : `rgb(${Math.floor(150 * crackPulse)},${Math.floor(50 * crackPulse)},${Math.floor(220 * crackPulse)})`;
                ctx.fillRect(x + 2, y + 3, w - 4, h - 4);
                // Crystal spikes
                ctx.fillStyle = flash ? '#eee' : '#bb66ee';
                ctx.fillRect(x + 1, y, 3, 3);
                ctx.fillRect(x + w - 4, y + 1, 3, 3);
                ctx.fillRect(x + w / 2 - 1, y - 2, 2, 4);
                // Eyes — glowing
                ctx.fillStyle = '#ff44ff';
                ctx.fillRect(x + 3, y + 4, 2, 2);
                ctx.fillRect(x + w - 5, y + 4, 2, 2);
                // Glow effect
                ctx.globalAlpha = crackPulse * 0.2;
                ctx.fillStyle = '#9944dd';
                ctx.fillRect(x - 2, y - 2, w + 4, h + 4);
                ctx.globalAlpha = 1;
                break;
            }
            case 'ROOT_GUARDIAN': {
                // Wooden humanoid with mossy armor
                const rgWalk = m.ground ? Math.sin(time / 150 + m.id * 5) * 2 : 0;
                // Legs — thick wood
                ctx.fillStyle = flash ? '#ddd' : '#5a3a1a';
                ctx.fillRect(x + 2, y + 14, 5, 8 + rgWalk);
                ctx.fillRect(x + w - 7, y + 14, 5, 8 - rgWalk);
                // Body — bark textured
                ctx.fillStyle = flash ? '#ccc' : '#3a2a10';
                ctx.fillRect(x + 1, y + 4, w - 2, 12);
                // Moss patches
                ctx.fillStyle = '#1a8833';
                ctx.fillRect(x + 2, y + 5, 4, 3);
                ctx.fillRect(x + w - 6, y + 8, 4, 3);
                // Head — wooden
                ctx.fillStyle = flash ? '#eee' : '#6a4a20';
                ctx.fillRect(x + 3, y, w - 6, 5);
                // Branch antlers
                ctx.fillStyle = '#5a3a1a';
                ctx.fillRect(x + 1, y - 3, 2, 4);
                ctx.fillRect(x + w - 3, y - 3, 2, 4);
                ctx.fillRect(x, y - 4, 2, 2);
                ctx.fillRect(x + w - 2, y - 4, 2, 2);
                // Eyes — green glow
                ctx.fillStyle = '#44ff88';
                ctx.fillRect(x + 4, y + 1, 2, 2);
                ctx.fillRect(x + w - 6, y + 1, 2, 2);
                // Arms
                ctx.fillStyle = flash ? '#bbb' : '#4a3a15';
                ctx.fillRect(x - 2, y + 6 + rgWalk, 4, 8);
                ctx.fillRect(x + w - 2, y + 6 - rgWalk, 4, 8);
                // Leaf shoulder pads
                ctx.fillStyle = '#22aa44';
                ctx.fillRect(x - 1, y + 4, 4, 3);
                ctx.fillRect(x + w - 3, y + 4, 4, 3);
                break;
            }
            case 'TREE_SPIRIT': {
                // Floating leaf-like spirit
                const floatY = Math.sin(time / 300 + m.id * 1.7) * 4;
                const spiritAlpha = 0.6 + Math.sin(time / 500 + m.id) * 0.2;
                ctx.globalAlpha = spiritAlpha;
                // Body — glowing green orb
                ctx.fillStyle = flash ? '#fff' : '#44ff88';
                ctx.fillRect(x + 2, y + 2 + floatY, w - 4, h - 4);
                ctx.fillStyle = '#88ffaa';
                ctx.fillRect(x + 3, y + 3 + floatY, w - 6, h - 6);
                // Leaf wings
                ctx.fillStyle = '#22aa44';
                ctx.fillRect(x - 3, y + 3 + floatY, 4, 6);
                ctx.fillRect(x + w - 1, y + 3 + floatY, 4, 6);
                // Eyes
                ctx.fillStyle = '#fff';
                ctx.fillRect(x + 3, y + 4 + floatY, 2, 2);
                ctx.fillRect(x + w - 5, y + 4 + floatY, 2, 2);
                // Trail particles effect
                ctx.globalAlpha = spiritAlpha * 0.3;
                ctx.fillStyle = '#88ffcc';
                ctx.fillRect(x + 1, y + h + floatY, w - 2, 4);
                ctx.globalAlpha = 1;
                break;
            }
            case 'BARK_GOLEM': {
                // Massive tree creature — very detailed
                const bgWalk = m.ground ? Math.sin(time / 200 + m.id * 3) * 2 : 0;
                const bgPulse = Math.sin(time / 600 + m.id) * 0.1 + 0.9;
                // Legs — massive trunks
                ctx.fillStyle = flash ? '#ccc' : '#3a2a10';
                ctx.fillRect(x + 2, y + 18, 7, 10 + bgWalk);
                ctx.fillRect(x + w - 9, y + 18, 7, 10 - bgWalk);
                // Root-like feet
                ctx.fillStyle = '#5a3a1a';
                ctx.fillRect(x, y + 26 + bgWalk, 10, 2);
                ctx.fillRect(x + w - 10, y + 26 - bgWalk, 10, 2);
                // Body — massive bark chest
                ctx.fillStyle = flash ? '#ddd' : `rgb(${Math.floor(60 * bgPulse)},${Math.floor(42 * bgPulse)},${Math.floor(16 * bgPulse)})`;
                ctx.fillRect(x + 1, y + 6, w - 2, 14);
                // Bark texture lines
                ctx.fillStyle = '#2a1a08';
                for (let i = 0; i < 3; i++) {
                    ctx.fillRect(x + 3 + i * 6, y + 7, 1, 12);
                }
                // Moss
                ctx.fillStyle = '#1a7722';
                ctx.fillRect(x + 2, y + 8, 5, 3);
                ctx.fillRect(x + w - 7, y + 10, 5, 3);
                ctx.fillRect(x + 8, y + 6, 6, 2);
                // Head — gnarled
                ctx.fillStyle = flash ? '#eee' : '#5a4020';
                ctx.fillRect(x + 4, y, w - 8, 7);
                // Crown of branches
                ctx.fillStyle = '#4a3a15';
                ctx.fillRect(x + 2, y - 4, 3, 5);
                ctx.fillRect(x + w - 5, y - 4, 3, 5);
                ctx.fillRect(x + 7, y - 6, 2, 7);
                ctx.fillRect(x + w - 9, y - 5, 2, 6);
                // Leaves on crown
                ctx.fillStyle = '#22aa44';
                ctx.fillRect(x + 1, y - 5, 4, 2);
                ctx.fillRect(x + w - 5, y - 5, 4, 2);
                ctx.fillRect(x + 6, y - 7, 4, 2);
                ctx.fillRect(x + w - 10, y - 6, 4, 2);
                // Eyes — ancient amber
                ctx.fillStyle = '#ffaa22';
                ctx.fillRect(x + 6, y + 2, 3, 2);
                ctx.fillRect(x + w - 9, y + 2, 3, 2);
                ctx.fillStyle = '#885511';
                ctx.fillRect(x + 7, y + 2, 1, 2);
                ctx.fillRect(x + w - 8, y + 2, 1, 2);
                // Arms — thick branches
                ctx.fillStyle = flash ? '#bbb' : '#4a3215';
                ctx.fillRect(x - 4, y + 7 + bgWalk, 6, 12);
                ctx.fillRect(x + w - 2, y + 7 - bgWalk, 6, 12);
                // Claws/roots at arm ends
                ctx.fillStyle = '#3a2510';
                ctx.fillRect(x - 5, y + 17 + bgWalk, 3, 3);
                ctx.fillRect(x + w + 2, y + 17 - bgWalk, 3, 3);
                // Glowing sap veins
                ctx.fillStyle = `rgba(220,170,34,${bgPulse * 0.6})`;
                ctx.fillRect(x + 4, y + 10, 1, 6);
                ctx.fillRect(x + w - 5, y + 8, 1, 8);
                ctx.fillRect(x + 10, y + 12, 1, 5);
                break;
            }
            case 'SAP_WISP': {
                // Tiny glowing sap droplet floating
                const wispFloat = Math.sin(time / 250 + m.id * 2.3) * 5;
                const wispPulse = Math.sin(time / 350 + m.id * 1.1) * 0.3 + 0.7;
                ctx.globalAlpha = wispPulse;
                // Glow
                ctx.fillStyle = `rgba(220,170,34,${wispPulse * 0.3})`;
                ctx.fillRect(x - 3, y - 3 + wispFloat, w + 6, h + 6);
                // Body
                ctx.fillStyle = '#ffcc44';
                ctx.fillRect(x + 1, y + 1 + wispFloat, w - 2, h - 2);
                ctx.fillStyle = '#ffee88';
                ctx.fillRect(x + 2, y + 2 + wispFloat, w - 4, h - 4);
                // Sparkle
                ctx.fillStyle = '#fff';
                ctx.fillRect(x + 2, y + 2 + wispFloat, 1, 1);
                ctx.globalAlpha = 1;
                break;
            }
            case 'TRADER': {
                // Body (robe)
                ctx.fillStyle = flash ? '#fff' : '#2a4a8a';
                ctx.fillRect(x + 3, y + 6 + walk, w - 6, h - 10);
                ctx.fillStyle = '#3a5a9a'; ctx.fillRect(x + 3, y + 7 + walk, w - 6, 6);
                // Gold trim on robe
                ctx.fillStyle = '#ffd700'; ctx.fillRect(x + 3, y + h - 5 + walk, w - 6, 1);
                // Belt with pouch
                ctx.fillStyle = '#aa8833'; ctx.fillRect(x + 3, y + 13 + walk, w - 6, 2);
                ctx.fillStyle = '#8a6a22'; ctx.fillRect(x + 5, y + 13 + walk, 3, 3); // pouch
                // Arms
                ctx.fillStyle = flash ? '#fcc' : '#ffcc88';
                ctx.fillRect(x + 1, y + 8 + walk, 2, 5); ctx.fillRect(x + w - 3, y + 8 + walk, 2, 5);
                // Head
                ctx.fillStyle = '#d4a574'; ctx.fillRect(x + 3, y + 2 + walk, w - 6, 5);
                // Hat (fez style)
                ctx.fillStyle = '#8a3030'; ctx.fillRect(x + 2, y - 1 + walk, w - 4, 4);
                ctx.fillRect(x + 4, y - 3 + walk, w - 8, 3);
                // Tassel
                ctx.fillStyle = '#ffd700'; ctx.fillRect(x + w - 4, y - 2 + walk, 2, 3);
                // Gold trim
                ctx.fillStyle = '#ffd700'; ctx.fillRect(x + 2, y + 2 + walk, w - 4, 1);
                // Eyes
                ctx.fillStyle = '#222'; ctx.fillRect(x + 4, y + 3 + walk, 1, 2); ctx.fillRect(x + w - 5, y + 3 + walk, 1, 2);
                // Beard
                ctx.fillStyle = '#8a7a5a'; ctx.fillRect(x + 4, y + 6 + walk, w - 8, 2);
                // Legs
                ctx.fillStyle = '#2a3a6a';
                ctx.fillRect(x + 3, y + h - 4, 3, 4 + walk); ctx.fillRect(x + w - 6, y + h - 4, 3, 4 + walk);
                // Floating trade indicator (coin)
                const ti = Math.sin(time / 300 + m.id) * 2;
                ctx.fillStyle = '#ffd700'; ctx.fillRect(x + w / 2 - 3, y - 10 + ti, 6, 6);
                ctx.fillStyle = '#ffee88'; ctx.fillRect(x + w / 2 - 2, y - 9 + ti, 4, 4);
                ctx.fillStyle = '#cc9900'; ctx.fillRect(x + w / 2 - 1, y - 8 + ti, 2, 2);
                break;
            }
            case 'GUARD': {
                const gWalk = m.ground ? Math.sin(time / 140 + m.id * 5) * 2 : 0;
                // Legs (armored)
                ctx.fillStyle = flash ? '#bbb' : '#5a5a6a';
                ctx.fillRect(x + 2, y + 16, 4, 8 + gWalk); ctx.fillRect(x + w - 6, y + 16, 4, 8 - gWalk);
                // Boots
                ctx.fillStyle = '#3a3a4a';
                ctx.fillRect(x + 1, y + 23 + gWalk, 5, 1); ctx.fillRect(x + w - 6, y + 23 - gWalk, 5, 1);
                // Body (chain mail)
                ctx.fillStyle = flash ? '#ddd' : '#7a7a8a';
                ctx.fillRect(x + 1, y + 6, w - 2, 11);
                ctx.fillStyle = '#6a6a7a'; ctx.fillRect(x + 2, y + 7, w - 4, 4);
                // Shoulder plates
                ctx.fillStyle = '#8a8a9a';
                ctx.fillRect(x - 1, y + 5, 3, 4); ctx.fillRect(x + w - 2, y + 5, 3, 4);
                // Belt
                ctx.fillStyle = '#4a3a1a'; ctx.fillRect(x + 1, y + 15, w - 2, 2);
                ctx.fillStyle = '#ccaa44'; ctx.fillRect(x + 4, y + 15, 2, 2);
                // Head
                ctx.fillStyle = flash ? '#fcc' : '#ffcc88'; ctx.fillRect(x + 2, y + 1, 6, 5);
                // Helmet
                ctx.fillStyle = '#6a6a7a'; ctx.fillRect(x, y - 2, w, 4); ctx.fillRect(x + 2, y - 4, w - 4, 3);
                ctx.fillStyle = '#8a8a9a'; ctx.fillRect(x + 3, y - 3, w - 6, 1);
                // Visor
                ctx.fillStyle = '#4a4a5a'; ctx.fillRect(x + 1, y + 1, w - 2, 1);
                // Eyes through visor
                ctx.fillStyle = '#fff'; ctx.fillRect(x + 4, y + 2, 2, 1); ctx.fillRect(x + w - 6, y + 2, 2, 1);
                // Spear
                ctx.fillStyle = '#6a5a3a'; ctx.fillRect(x + w, y - 2, 1, 20);
                ctx.fillStyle = '#bbb'; ctx.fillRect(x + w - 1, y - 5, 3, 4);
                // Shield (on left)
                ctx.fillStyle = '#5a5a7a'; ctx.fillRect(x - 3, y + 8, 4, 8);
                ctx.fillStyle = '#7a7a9a'; ctx.fillRect(x - 2, y + 9, 2, 6);
                ctx.fillStyle = '#ccaa44'; ctx.fillRect(x - 2, y + 11, 2, 2); // shield emblem
                break;
            }
            case 'BLOOD_CRAWLER': {
                // Fast spider-like vampire crawler
                ctx.fillStyle = flash ? '#fff' : '#6a1010';
                ctx.fillRect(x + 2, y + 2, w - 4, h - 4);
                ctx.fillStyle = flash ? '#faa' : '#aa2020';
                ctx.fillRect(x + 3, y + 1, w - 6, 3);
                // Legs
                ctx.fillStyle = '#4a0808';
                for (let i = 0; i < 4; i++) {
                    const lo2 = Math.sin(time / 80 + i * 1.5) * 2;
                    ctx.fillRect(x - 2 + i * 4, y + h - 2 + lo2, 2, 3);
                }
                // Red eyes
                ctx.fillStyle = '#ff3333';
                ctx.fillRect(x + 3, y + 2, 2, 1);
                ctx.fillRect(x + w - 5, y + 2, 2, 1);
                break;
            }
            case 'BLOOD_KNIGHT': {
                // Armored undead knight
                const bkWalk = m.ground ? Math.sin(time / 140 + m.id * 5) * 2 : 0;
                // Legs
                ctx.fillStyle = flash ? '#aaa' : '#3a1a1a';
                ctx.fillRect(x + 3, y + 18, 4, 8 + bkWalk);
                ctx.fillRect(x + w - 7, y + 18, 4, 8 - bkWalk);
                // Body armor
                ctx.fillStyle = flash ? '#ddd' : '#5a2020';
                ctx.fillRect(x + 1, y + 6, w - 2, 13);
                ctx.fillStyle = flash ? '#eee' : '#7a3030';
                ctx.fillRect(x + 2, y + 7, w - 4, 5);
                // Shield
                ctx.fillStyle = '#4a1515';
                ctx.fillRect(x - 2, y + 8, 4, 8);
                ctx.fillStyle = '#8a2020';
                ctx.fillRect(x - 1, y + 9, 2, 6);
                // Head with helm
                ctx.fillStyle = flash ? '#eee' : '#6a2828';
                ctx.fillRect(x + 3, y, w - 6, 7);
                ctx.fillStyle = '#4a1818';
                ctx.fillRect(x + 2, y - 1, w - 4, 3);
                // Eyes - red glow
                ctx.fillStyle = '#ff4444';
                ctx.fillRect(x + 4, y + 3, 2, 2);
                ctx.fillRect(x + w - 6, y + 3, 2, 2);
                break;
            }
            case 'GOBLIN_WARRIOR': {
                const gwWalk = m.ground ? Math.sin(time / 120 + m.id * 6) * 2 : 0;
                // Legs - green
                ctx.fillStyle = flash ? '#aaa' : '#2a5a1a';
                ctx.fillRect(x + 2, y + 14, 3, 6 + gwWalk);
                ctx.fillRect(x + w - 5, y + 14, 3, 6 - gwWalk);
                // Body
                ctx.fillStyle = flash ? '#ccc' : '#3a7a2a';
                ctx.fillRect(x + 1, y + 5, w - 2, 10);
                // Armor piece
                ctx.fillStyle = '#5a3a1a';
                ctx.fillRect(x + 2, y + 6, w - 4, 3);
                // Arms with sword
                ctx.fillStyle = flash ? '#bbb' : '#4a8a3a';
                ctx.fillRect(x + w, y + 7 + gwWalk, 3, 5);
                ctx.fillStyle = '#aaa';
                ctx.fillRect(x + w + 1, y + 4 + gwWalk, 1, 5);
                // Head
                ctx.fillStyle = flash ? '#ddd' : '#4a9a3a';
                ctx.fillRect(x + 2, y, w - 4, 6);
                // Pointy ears
                ctx.fillRect(x, y + 1, 2, 3);
                ctx.fillRect(x + w - 2, y + 1, 2, 3);
                // Eyes
                ctx.fillStyle = '#ff0';
                ctx.fillRect(x + 3, y + 2, 2, 2);
                ctx.fillRect(x + w - 5, y + 2, 2, 2);
                break;
            }
            case 'GOBLIN_MAGE': {
                // Floating goblin with magical aura
                const gmFloat = Math.sin(time / 300 + m.id * 3) * 4;
                const mgY = y + gmFloat;
                // Robe
                ctx.fillStyle = flash ? '#ddd' : '#2a1a5a';
                ctx.fillRect(x + 1, mgY + 5, w - 2, 13);
                ctx.fillStyle = '#3a2a6a';
                ctx.fillRect(x + 2, mgY + 6, w - 4, 4);
                // Head
                ctx.fillStyle = flash ? '#eee' : '#4a9a3a';
                ctx.fillRect(x + 2, mgY, w - 4, 6);
                // Hat
                ctx.fillStyle = '#2a1a5a';
                ctx.fillRect(x + 1, mgY - 3, w - 2, 4);
                ctx.fillRect(x + 3, mgY - 6, w - 6, 3);
                // Eyes - glowing
                const mgGlow = Math.sin(time / 200) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(200,100,255,${mgGlow})`;
                ctx.fillRect(x + 3, mgY + 2, 2, 2);
                ctx.fillRect(x + w - 5, mgY + 2, 2, 2);
                // Magic orb
                ctx.fillStyle = `rgba(150,80,255,${mgGlow * 0.6})`;
                ctx.beginPath();
                ctx.arc(x + w + 3, mgY + 8, 3 + Math.sin(time / 150) * 1, 0, Math.PI * 2);
                ctx.fill();
                break;
            }
            case 'GOBLIN_BRUTE': {
                const gbWalk = m.ground ? Math.sin(time / 160 + m.id * 4) * 3 : 0;
                // Huge legs
                ctx.fillStyle = flash ? '#aaa' : '#2a5a1a';
                ctx.fillRect(x + 3, y + 18, 6, 8 + gbWalk);
                ctx.fillRect(x + w - 9, y + 18, 6, 8 - gbWalk);
                // Massive body
                ctx.fillStyle = flash ? '#ccc' : '#3a6a2a';
                ctx.fillRect(x + 1, y + 6, w - 2, 14);
                ctx.fillStyle = '#4a3a1a';
                ctx.fillRect(x + 2, y + 7, w - 4, 5);
                // Huge arms
                ctx.fillStyle = flash ? '#bbb' : '#3a7a2a';
                ctx.fillRect(x - 3, y + 8 + gbWalk, 5, 10);
                ctx.fillRect(x + w - 2, y + 8 - gbWalk, 5, 10);
                // Club
                ctx.fillStyle = '#5a3a1a';
                ctx.fillRect(x + w, y + 4 - gbWalk, 3, 14);
                ctx.fillStyle = '#4a2a0a';
                ctx.fillRect(x + w - 1, y + 2 - gbWalk, 5, 4);
                // Head - small relative to body
                ctx.fillStyle = flash ? '#ddd' : '#4a9a3a';
                ctx.fillRect(x + 5, y, w - 10, 7);
                ctx.fillStyle = '#ff0';
                ctx.fillRect(x + 7, y + 2, 2, 2);
                ctx.fillRect(x + w - 9, y + 2, 2, 2);
                // War paint
                ctx.fillStyle = '#cc2222';
                ctx.fillRect(x + 6, y + 4, w - 12, 1);
                break;
            }
            case 'ECLIPSE_MOTH': {
                // Dark moth with glowing wing patterns
                const mFlap = Math.sin(time / 80 + m.id * 3) * 3;
                const mBody = y + 4;
                // Wings
                const wGlow = Math.sin(time / 200 + m.id) * 0.3 + 0.7;
                ctx.fillStyle = `rgba(60,20,80,${flash ? 1 : 0.8})`;
                ctx.fillRect(x - 2 - mFlap, mBody - 2, 7, 8);
                ctx.fillRect(x + w - 5 + mFlap, mBody - 2, 7, 8);
                // Wing patterns
                ctx.fillStyle = `rgba(200,100,255,${wGlow * 0.5})`;
                ctx.fillRect(x - 1 - mFlap, mBody, 3, 3);
                ctx.fillRect(x + w - 3 + mFlap, mBody, 3, 3);
                // Body
                ctx.fillStyle = flash ? '#ddd' : '#3a1a4a';
                ctx.fillRect(x + 4, mBody - 1, w - 8, 6);
                // Eyes
                ctx.fillStyle = `rgba(255,200,255,${wGlow})`;
                ctx.fillRect(x + 4, mBody, 2, 2);
                ctx.fillRect(x + w - 6, mBody, 2, 2);
                break;
            }
            case 'REAPER': {
                // Teleporting reaper with scythe
                const rpFloat = Math.sin(time / 250 + m.id * 2) * 3;
                const rpY = y + rpFloat;
                const rpAlpha = m.ai.stateTimer < 200 ? m.ai.stateTimer / 200 : 1;
                ctx.globalAlpha = flash ? 1 : rpAlpha * 0.85;
                // Cloak
                ctx.fillStyle = flash ? '#888' : '#0a0a1a';
                ctx.fillRect(x + 1, rpY + 4, w - 2, 20);
                ctx.fillStyle = '#1a0a2a';
                ctx.fillRect(x + 2, rpY + 5, w - 4, 8);
                // Hood
                ctx.fillStyle = '#0a0a1a';
                ctx.fillRect(x + 2, rpY, w - 4, 6);
                ctx.fillRect(x + 1, rpY + 2, w - 2, 3);
                // Glowing eyes under hood
                ctx.fillStyle = '#ff2244';
                ctx.fillRect(x + 4, rpY + 2, 2, 2);
                ctx.fillRect(x + w - 6, rpY + 2, 2, 2);
                // Eye glow
                ctx.fillStyle = `rgba(255,30,60,${Math.sin(time / 150) * 0.3 + 0.4})`;
                ctx.fillRect(x + 3, rpY + 1, 4, 4);
                ctx.fillRect(x + w - 7, rpY + 1, 4, 4);
                // Scythe
                ctx.fillStyle = '#555';
                ctx.fillRect(x + w - 1, rpY + 3, 2, 16);
                ctx.fillStyle = '#bbb';
                ctx.beginPath();
                ctx.moveTo(x + w + 1, rpY + 3);
                ctx.lineTo(x + w + 8, rpY + 6);
                ctx.lineTo(x + w + 1, rpY + 10);
                ctx.fill();
                ctx.globalAlpha = 1;
                break;
            }
            case 'LIGHTNING_WRAITH': {
                // Electrical ghost entity
                const lwFloat = Math.sin(time / 200 + m.id * 4) * 4;
                const lwY = y + lwFloat;
                const lwAlpha = 0.6 + Math.sin(time / 100 + m.id) * 0.2;
                ctx.globalAlpha = flash ? 1 : lwAlpha;
                // Body - ethereal
                ctx.fillStyle = flash ? '#fff' : 'rgba(140,200,255,0.7)';
                ctx.fillRect(x + 2, lwY + 2, w - 4, h - 4);
                ctx.fillStyle = 'rgba(180,220,255,0.5)';
                ctx.fillRect(x + 3, lwY + 3, w - 6, h - 8);
                // Electrical arcs
                if (Math.sin(time / 60 + m.id * 3) > 0.3) {
                    ctx.strokeStyle = 'rgba(200,230,255,0.8)';
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.moveTo(x + w / 2, lwY);
                    ctx.lineTo(x + w / 2 + (Math.random() - 0.5) * 10, lwY - 8);
                    ctx.stroke();
                }
                // Eyes
                ctx.fillStyle = '#fff';
                ctx.fillRect(x + 3, lwY + 4, 3, 3);
                ctx.fillRect(x + w - 6, lwY + 4, 3, 3);
                ctx.fillStyle = '#88ccff';
                ctx.fillRect(x + 4, lwY + 5, 1, 1);
                ctx.fillRect(x + w - 5, lwY + 5, 1, 1);
                ctx.globalAlpha = 1;
                break;
            }
            default: { ctx.fillStyle = flash ? '#fff' : '#888'; ctx.fillRect(x + 1, y + 1, w - 2, h - 2); break; }
        }
        ctx.restore();
        // HP bar (outside transform)
        if (m.hp < m.maxHp) { ctx.fillStyle = '#300'; ctx.fillRect(x, y - 5, w, 3); ctx.fillStyle = '#f00'; ctx.fillRect(x, y - 5, w * (m.hp / m.maxHp), 3); }
        // === SPEECH BUBBLES & SLEEP ZZZ (outside transform so text isn't mirrored) ===
        if (m.def && m.def.isVillager && m.ai) {
            // Sleep ZZZ
            if (m.ai.state === 'v_sleep') {
                const zt = time / 400;
                ctx.save();
                ctx.globalAlpha = 0.5 + Math.sin(zt) * 0.3;
                ctx.fillStyle = '#ccccff';
                ctx.font = '6px monospace';
                ctx.fillText('z', x + w / 2 + Math.sin(zt) * 2, y - 6 + Math.sin(zt * 0.7) * 2);
                ctx.font = '8px monospace';
                ctx.fillText('Z', x + w / 2 + 5 + Math.sin(zt + 1) * 2, y - 12 + Math.sin(zt * 0.5) * 2);
                ctx.restore();
            }
            // Speech bubble
            if (m.ai.speechShow > 0 && m.ai.speechText) {
                const bubAlpha = Math.min(1, m.ai.speechShow / 500);
                ctx.save();
                ctx.globalAlpha = bubAlpha;
                const txt = m.ai.speechText;
                ctx.font = '7px monospace';
                const tw = ctx.measureText(txt).width;
                const bx2 = x + w / 2 - tw / 2 - 4;
                const by2 = y - 18;
                // Bubble background with rounded feel
                ctx.fillStyle = 'rgba(255,255,255,0.92)';
                ctx.fillRect(bx2 - 1, by2, tw + 10, 13);
                // Bubble border
                ctx.fillStyle = 'rgba(0,0,0,0.15)';
                ctx.fillRect(bx2 - 2, by2 - 1, tw + 12, 1);
                ctx.fillRect(bx2 - 2, by2 + 13, tw + 12, 1);
                ctx.fillRect(bx2 - 2, by2, 1, 13);
                ctx.fillRect(bx2 + tw + 9, by2, 1, 13);
                // Bubble tail
                ctx.fillStyle = 'rgba(255,255,255,0.92)';
                ctx.fillRect(x + w / 2 - 2, by2 + 13, 4, 3);
                // Text
                ctx.fillStyle = '#222';
                ctx.fillText(txt, bx2 + 4, by2 + 10);
                ctx.restore();
            }
        }
    }
}